webpackJsonp([3,1],{

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dialog = __webpack_require__(69);
	
	var _dialog2 = _interopRequireDefault(_dialog);
	
	var _edrone2 = __webpack_require__(137);
	
	var _edrone3 = _interopRequireDefault(_edrone2);
	
	var _localCart = __webpack_require__(350);
	
	var _localCart2 = _interopRequireDefault(_localCart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatValues(title, values, after) {
	    var html = '';
	    html += '<div class="values table-values">' + ('<div class="values-title">' + title + '</div>') + '<div class="values-rows">';
	    values.forEach(function (val) {
	        var t = val.title.replace('-', "<div class='tab'></div>");
	        html += '<div class="values-row">' + ('<div class="values-title">' + t + '</div>') + ('<div class="values-val">' + val.value + '</div>') + '</div>';
	    });
	    html += '</div>'; //.rows
	    html += after ? '<div class="after">' + after + '</div>' : '';
	    html += '</div>'; //.table-values
	    return html;
	}
	
	$(document.body).on("update_html_fragments", function (_event, fragments) {
	    if (!fragments) {
	        return;
	    }
	    $.each(fragments, function (selector, html) {
	        $(selector).replaceWith(html);
	    });
	});
	
	$(document).on('ready', function () {
	    $("body").on('click', '.open-juice-popup', function (ev) {
	
	        var self = $(ev.currentTarget);
	
	        if (typeof self.data('product_cat') == 'undefined') {
	            self = self.closest('.juice_packs_content').find("[data-product_cat]");
	        }
	        _edrone3.default.push(function (_edrone) {
	            _edrone.action_type = 'product_view';
	            _edrone.product_images = self.data('product_img');
	            _edrone.product_category_names = self.data('product_cat');
	            _edrone.product_titles = self.data('product_title');
	            _edrone.product_ids = self.data('product-id') || self.data('diet_id');
	            _edrone.product_urls = window.location.href;
	            _edrone.init();
	        });
	
	        var pid = ev.currentTarget.getAttribute('data-product-id');
	
	        $.post(backend.ajax, { action: 'ncp_open_juice_popup', product_id: pid }, function (data) {
	            if (data && data.fragments) {
	                $(document.body).trigger("update_html_fragments", [data.fragments]);
	            }
	        });
	
	        var j = window.juice_popups['product_' + pid];
	        var html = '';
	        var srcset = '';
	        if (j.big_image.srcset && j.big_image.srcset.length) {
	            srcset = 'srcset="' + j.big_image.srcset + '"';
	        }
	        html += '<div class="juice-popup-content" ' + (j.is_upsell ? 'data-cart_type="upsell"' : '') + '>' + '<div class="product-top">' + '<div class="product-info">' + ('<h2 class="title">' + j.title + '</h2>') + ('<div class="ingredients">' + j.ingredients + '</div>') + ('<div class="omnibus">' + j.omnibus + '</div>') + ('<div class="desc">' + j.description + '</div>') + '</div>' //.product-info
	        + '<div class="product-img-wrap">' + ('<img class="product-img" src="' + j.big_image.src + '" ' + srcset + ' alt="">') + '</div>' //.product-img
	        + '</div>'; //.product-top
	
	        if (j.values.length || j.vitamins.length) {
	            html += '<div class="product-values">';
	            if (j.values.length) {
	                html += formatValues('Wartości odżywcze w 100ml', j.values);
	            }
	            if (j.vitamins.length) {
	                html += formatValues('Witaminy *', j.vitamins, '* Wartości Wskazanego Dziennego Spożycia (GDA) dla osoby dorosłej na poziomie 2000 kcal.');
	            }
	            html += '</div>'; //.product-values
	        }
	        if (j.is_upsell) {
	            html += '<a href="#"\n                        class="ghost_button bg_red ladda-button add-upsell-to-cart"\n                        data-product-id="' + j.id + '"\n                        data-product-name="' + j.title + '"\n                        id="" data-style="expand-right">\n                        <span class="ladda-label">Dodaj +' + j.price + '</span>\n                        <span class="ladda-spinner"></span>\n                    </a>';
	        }
	        html += '</div>'; //.juice-popup-content
	        var dlg = new _dialog2.default(html);
	        setTimeout(function () {
	
	            _localCart2.default.create(dlg.get$El().find('.juice-popup-content'));
	        });
	    });
	});

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(49);
	module.exports = __webpack_require__(371);


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _desc, _value, _class;
	
	var _autobindDecorator = __webpack_require__(97);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _modernizr = __webpack_require__(347);
	
	var _modernizr2 = _interopRequireDefault(_modernizr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	    var desc = {};
	    Object['ke' + 'ys'](descriptor).forEach(function (key) {
	        desc[key] = descriptor[key];
	    });
	    desc.enumerable = !!desc.enumerable;
	    desc.configurable = !!desc.configurable;
	
	    if ('value' in desc || desc.initializer) {
	        desc.writable = true;
	    }
	
	    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	        return decorator(target, property, desc) || desc;
	    }, desc);
	
	    if (context && desc.initializer !== void 0) {
	        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	        desc.initializer = undefined;
	    }
	
	    if (desc.initializer === void 0) {
	        Object['define' + 'Property'](target, property, desc);
	        desc = null;
	    }
	
	    return desc;
	}
	
	var support = { animations: _modernizr2.default.cssanimations },
	    animEndEventNames = {
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd',
	    'animation': 'animationend'
	},
	    animEndEventName = animEndEventNames[_modernizr2.default.prefixed('animation')],
	    onEndAnimation = function onEndAnimation(el, callback) {
	    var onEndCallbackFn = function onEndCallbackFn(ev) {
	        if (support.animations) {
	            if (ev.target != this) return;
	            this.removeEventListener(animEndEventName, onEndCallbackFn);
	        }
	        if (callback && typeof callback === 'function') {
	            callback.call();
	        }
	    };
	    if (support.animations) {
	        el.addEventListener(animEndEventName, onEndCallbackFn);
	    } else {
	        onEndCallbackFn();
	    }
	};
	
	var Dialog = (_class = function () {
	    function Dialog(el, options) {
	        _classCallCheck(this, Dialog);
	
	        if (typeof el == "string") {
	            //create from text/html
	            $("#dialog_template .dialog__content__body").html(el);
	            el = $("#dialog_template")[0];
	        }
	        this.$el = $(el);
	        this.options = Object.assign({ onOpenDialog: function onOpenDialog() {
	                return false;
	            }, onCloseDialog: function onCloseDialog() {
	                return false;
	            } }, options);
	        this.open();
	    }
	
	    _createClass(Dialog, [{
	        key: 'toggle',
	        value: function toggle() {
	            if (this.isOpen) {
	                this.close();
	            } else {
	                this.open();
	            }
	        }
	    }, {
	        key: 'get$El',
	        value: function get$El() {
	            return this.$el;
	        }
	    }, {
	        key: 'handleKeyDown',
	        value: function handleKeyDown(ev) {
	            var keyCode = ev.keyCode || ev.which;
	            if (keyCode == 27 && this.isOpen) {
	                this.toggle();
	            }
	        }
	    }, {
	        key: 'open',
	        value: function open() {
	            this.isOpen = true;
	            // EVENTS
	            /**
	             * Legacy selector
	             */
	            this.$el.find("[data-dialog-close]").on('click', this.close);
	            /**
	             * Current close selector
	             */
	            this.$el.find('.close_dialog').on('click', this.close);
	            this.$el.find('.dialog__overlay').on('click', this.close);
	            $(document).on('keydown', this.handleKeyDown);
	
	            this.$el.addClass('dialog--open');
	            this.options.onOpenDialog(this);
	        }
	    }, {
	        key: 'close',
	        value: function close(ev) {
	            var _this = this;
	
	            this.isOpen = false;
	            // EVENTS
	            this.$el.find("[data-dialog-close]").off('click', this.close);
	            this.$el.find('.dialog__overlay').off('click', this.close);
	            $(document).off('keydown', this.handleKeyDown);
	
	            // ANIMATIONS
	            ev && ev.preventDefault && ev.preventDefault();
	            this.$el.removeClass('dialog--open').addClass('dialog--close');
	
	            onEndAnimation(this.$el.find('.dialog__content'), function () {
	                _this.$el.removeClass('dialog--close');
	            });
	            this.options.onCloseDialog(this);
	        }
	    }, {
	        key: 'setBody',
	        value: function setBody(html) {
	            this.$el.removeClass("is-empty").addClass('visible');
	            this.$el.find(".dialog__content__body").html(html);
	        }
	    }]);
	
	    return Dialog;
	}(), (_applyDecoratedDescriptor(_class.prototype, 'handleKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'open', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'open'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'close', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'close'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setBody', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'setBody'), _class.prototype)), _class);
	exports.default = Dialog;

/***/ }),

/***/ 137:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    push: function push(callback) {
	        if (!window.allowEdrone) {
	            return;
	        }
	        if (typeof _edrone == "undefined") {
	            return;
	        }
	        try {
	            callback(_edrone);
	        } catch (e) {
	            console.log("edrone exception");
	            if (typeof Raven != "undefined" && Raven.captureException) {
	                Raven.captureException(e);
	            }
	        }
	    }
	};

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _animejs = __webpack_require__(136);
	
	var _animejs2 = _interopRequireDefault(_animejs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canvas = void 0;
	var ctx = void 0;
	var distance = 100;
	var numberOfParticules = 24;
	var animations = void 0;
	var x = void 0,
	    y = void 0;
	var colors = [
	// '#FF324A',
	// '#31FFA6',
	// '#206EFF',
	// '#FFFF99',
	
	// '#067331',
	'#afd66b', '#afd66b', '#ffa735', '#dd0000'];
	var noop = function noop() {};
	var boom = function boom(ev) {
		var w = canvas.offsetWidth,
		    h = canvas.offsetHeight;
		x = ev.clientX || ev.touches[0].clientX;
		y = ev.clientY || ev.touches[0].clientY;
		// x -= canvas.getBoundingClientRect().left;
		// y -= canvas.getBoundingClientRect().top;
		// x = canvas.width / 2;
		// y = canvas.height / 2;
	
		canvas.style.left = x + 'px';
		canvas.style.top = y - h * 0.5 + 'px';
		canvas.render();
		x = w * 0.5;
		y = h * 0.5;
		animateParticles(x, y);
		canvas.classList.add('active');
	};
	var getFontSize = function getFontSize() {
		return 0.4 * parseFloat(getComputedStyle(document.documentElement).fontSize);
	};
	var setCanvasSize = function setCanvasSize() {
		var size = 500;
		canvas.width = size; //window.innerWidth;
		canvas.height = size; //window.innerHeight;
	};
	var createParticule = function createParticule(x, y) {
		var p = {};
		p.x = x;
		p.y = y;
		p.color = colors[_animejs2.default.random(0, colors.length - 1)];
		p.radius = _animejs2.default.random(getFontSize(), getFontSize() * 2);
		p.draw = function () {
			ctx.beginPath();
			ctx.arc(p.x, p.y, p.radius, 0, 2 * Math.PI, true);
			ctx.fillStyle = p.color;
			ctx.fill();
		};
		return p;
	};
	
	var createParticles = function createParticles(x, y) {
		var particules = [];
		for (var i = 0; i < numberOfParticules; i++) {
			var p = createParticule(x, y);
			particules.push(p);
		}
		return particules;
	};
	var animateParticles = function animateParticles(x, y) {
		setCanvasSize();
		var particules = createParticles(x, y);
		var particulesAnimation = (0, _animejs2.default)({
			targets: particules,
			x: function x(p) {
				return p.x + _animejs2.default.random(-distance, distance);
			},
			y: function y(p) {
				return p.y + _animejs2.default.random(-distance, distance);
			},
			radius: 0,
			duration: function duration() {
				return _animejs2.default.random(1200, 1800);
			},
			easing: 'easeOutExpo',
			complete: removeAnimation
		});
		animations.push(particulesAnimation);
	};
	var removeAnimation = function removeAnimation(animation) {
		var index = animations.indexOf(animation);
		if (index > -1) animations.splice(index, 1);
		if (animations.length == 0) {
			canvas.classList.remove('active');
		}
	};
	
	var init = function init(canvasSelector) {
		document.addEventListener('DOMContentLoaded', function () {
			if (!canvasSelector) {
				canvas = document.createElement('canvas');
				document.body.appendChild(canvas);
			} else {
				canvas = document.querySelector(canvasSelector);
			}
			canvas.addEventListener('click', boom);
			setCanvasSize();
			canvas.classList.add('boom');
			ctx = canvas.getContext('2d');
			x = 0;
			y = 0;
			animations = [];
	
			var mainLoop = (0, _animejs2.default)({
				duration: Infinity,
				update: function update() {
					ctx.clearRect(0, 0, canvas.width, canvas.height);
					animations.forEach(function (anim) {
						anim.animatables.forEach(function (animatable) {
							animatable.target.draw();
						});
					});
				}
			});
		}, false);
	};
	
	exports.default = {
		boom: window.enable_frontend_boom_effect ? boom : noop,
		init: window.enable_frontend_boom_effect ? init : noop
	};

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

	;(function(window){
	var hadGlobal = 'Modernizr' in window;
	var oldGlobal = window.Modernizr;
	/*! modernizr 3.8.0 (Custom Build) | MIT *
	 * https://modernizr.com/download/?-prefixed-prefixedcss-prefixes-setclasses !*/
	!function(e,n,t){function r(e,n){return typeof e===n}function o(e,n){return!!~(""+e).indexOf(n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):S?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function s(){var e=n.body;return e||(e=i(S?"svg":"body"),e.fake=!0),e}function l(e,t,r,o){var l,a,f,u,p="modernizr",c=i("div"),d=s();if(parseInt(r,10))for(;r--;)f=i("div"),f.id=o?o[r]:p+(r+1),c.appendChild(f);return l=i("style"),l.type="text/css",l.id="s"+p,(d.fake?d:c).appendChild(l),d.appendChild(c),l.styleSheet?l.styleSheet.cssText=e:l.appendChild(n.createTextNode(e)),c.id=p,d.fake&&(d.style.background="",d.style.overflow="hidden",u=C.style.overflow,C.style.overflow="hidden",C.appendChild(d)),a=t(c,e),d.fake?(d.parentNode.removeChild(d),C.style.overflow=u,C.offsetHeight):c.parentNode.removeChild(c),!!a}function a(e){return e.replace(/([A-Z])/g,function(e,n){return"-"+n.toLowerCase()}).replace(/^ms-/,"-ms-")}function f(n,t,r){var o;if("getComputedStyle"in e){o=getComputedStyle.call(e,n,t);var i=e.console;if(null!==o)r&&(o=o.getPropertyValue(r));else if(i){var s=i.error?"error":"log";i[s].call(i,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else o=!t&&n.currentStyle&&n.currentStyle[r];return o}function u(n,r){var o=n.length;if("CSS"in e&&"supports"in e.CSS){for(;o--;)if(e.CSS.supports(a(n[o]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var i=[];o--;)i.push("("+a(n[o])+":"+r+")");return i=i.join(" or "),l("@supports ("+i+") { #modernizr { position: absolute; } }",function(e){return"absolute"===f(e,null,"position")})}return t}function p(e){return e.replace(/([a-z])-([a-z])/g,function(e,n,t){return n+t.toUpperCase()}).replace(/^-/,"")}function c(e,n,s,l){function a(){c&&(delete b.style,delete b.modElem)}if(l=!r(l,"undefined")&&l,!r(s,"undefined")){var f=u(e,s);if(!r(f,"undefined"))return f}for(var c,d,m,v,y,h=["modernizr","tspan","samp"];!b.style&&h.length;)c=!0,b.modElem=i(h.shift()),b.style=b.modElem.style;for(m=e.length,d=0;d<m;d++)if(v=e[d],y=b.style[v],o(v,"-")&&(v=p(v)),b.style[v]!==t){if(l||r(s,"undefined"))return a(),"pfx"!==n||v;try{b.style[v]=s}catch(e){}if(b.style[v]!==y)return a(),"pfx"!==n||v}return a(),!1}function d(e,n){return function(){return e.apply(n,arguments)}}function m(e,n,t){var o;for(var i in e)if(e[i]in n)return!1===t?e[i]:(o=n[e[i]],r(o,"function")?d(o,t||n):o);return!1}function v(e,n,t,o,i){var s=e.charAt(0).toUpperCase()+e.slice(1),l=(e+" "+w.join(s+" ")+s).split(" ");return r(n,"string")||r(n,"undefined")?c(l,n,o,i):(l=(e+" "+z.join(s+" ")+s).split(" "),m(l,n,t))}var y=[],h={_version:"3.8.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){y.push({name:e,fn:n,options:t})},addAsyncTest:function(e){y.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=h,Modernizr=new Modernizr;var g=[],C=n.documentElement,S="svg"===C.nodeName.toLowerCase(),_="Moz O ms Webkit",w=h._config.usePrefixes?_.split(" "):[];h._cssomPrefixes=w;var x={elem:i("modernizr")};Modernizr._q.push(function(){delete x.elem});var b={style:x.elem.style};Modernizr._q.unshift(function(){delete b.style});var z=h._config.usePrefixes?_.toLowerCase().split(" "):[];h._domPrefixes=z,h.testAllProps=v;var E=function(n){var r,o=N.length,i=e.CSSRule;if(void 0===i)return t;if(!n)return!1;if(n=n.replace(/^@/,""),(r=n.replace(/-/g,"_").toUpperCase()+"_RULE")in i)return"@"+n;for(var s=0;s<o;s++){var l=N[s];if(l.toUpperCase()+"_"+r in i)return"@-"+l.toLowerCase()+"-"+n}return!1};h.atRule=E;var P=h.prefixed=function(e,n,t){return 0===e.indexOf("@")?E(e):(-1!==e.indexOf("-")&&(e=p(e)),n?v(e,n,t):v(e,"pfx"))},N=h._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];h._prefixes=N;h.prefixedCSS=function(e){var n=P(e);return n&&a(n)};!function(){var e,n,t,o,i,s,l;for(var a in y)if(y.hasOwnProperty(a)){if(e=[],n=y[a],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(o=r(n.fn,"function")?n.fn():n.fn,i=0;i<e.length;i++)s=e[i],l=s.split("."),1===l.length?Modernizr[l[0]]=o:(Modernizr[l[0]]&&(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean)||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=o),g.push((o?"":"no-")+l.join("-"))}}(),function(e){var n=C.className,t=Modernizr._config.classPrefix||"";if(S&&(n=n.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(r,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(e.length>0&&(n+=" "+t+e.join(" "+t)),S?C.className.baseVal=n:C.className=n)}(g),delete h.addTest,delete h.addAsyncTest;for(var j=0;j<Modernizr._q.length;j++)Modernizr._q[j]();e.Modernizr=Modernizr}(window,document);
	module.exports = window.Modernizr;
	if (hadGlobal) { window.Modernizr = oldGlobal; }
	else { delete window.Modernizr; }
	})(window);

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Cookies = {};
	
	Cookies.create = function (name, value, days) {
	    if (days) {
	        var date = new Date();
	        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	        var expires = "; expires=" + date.toGMTString();
	    } else var expires = "";
	    document.cookie = name + "=" + value + expires + "; path=/";
	    console.log('cookie created');
	};
	
	Cookies.read = function (name) {
	    var nameEQ = name + "=";
	    var ca = document.cookie.split(';');
	    for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	            c = c.substring(1, c.length);
	        }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	    }
	    return null;
	};
	
	Cookies.erase = function (name) {
	    this.create(name, "", -1);
	};
	
	exports.default = Cookies;

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _ladda = __webpack_require__(346);
	
	var _ladda2 = _interopRequireDefault(_ladda);
	
	var _dialog = __webpack_require__(69);
	
	var _dialog2 = _interopRequireDefault(_dialog);
	
	var _edrone2 = __webpack_require__(137);
	
	var _edrone3 = _interopRequireDefault(_edrone2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LocalCart($, $obj) {
	  if (this == window) {
	    return new LocalCart($, $obj);
	  }
	  var $cat = $obj.data('product_cat');
	  if (typeof $cat == 'undefined') {
	    $cat = 'sok';
	  }
	  this.$ = $;
	  this.type = $obj.data('cart_type');
	  this.product_category = $cat;
	  this.$cart = $obj;
	  this.$add = this.$cart.find('.mini_cart__add_to_cart,.add-upsell-to-cart');
	  this.ladda = _ladda2.default.create(this.$add[0]);
	  this.total_price = 0;
	  this.total_qty = 0;
	  this.products = {};
	  this.persons_qty = 0;
	  this.isAbonamentCheckout = window.isAbonamentCheckout;
	
	  if (this.type == 'diet') {
	    this.diet_id = $obj.data('diet_id');
	  } else if (this.type == 'juice_pack') {
	    this.juice_pack_id = $obj.data('product_id');
	  }
	  this.product_img = $obj.data('product_img');
	
	  //add hooks
	  this.addHooks();
	  return this;
	}
	
	jQuery.extend(LocalCart.prototype, {
	  addHooks: function addHooks() {
	    var self = this;
	    var $ = this.$;
	    if (this.type == 'page') {
	      this.addHooksPage();
	    } else {
	      this.addHooksDiet();
	      this.addHooksPage();
	    }
	  },
	  addHooksDiet: function addHooksDiet() {},
	
	  addHooksPage: function addHooksPage() {
	    var $ = this.$;
	    var self = this;
	    var $btn = null;
	    if (this.type == 'page') {
	      $btn = $('.categories_row').find('.product_less,.product_more');
	    } else {
	      $btn = this.$cart.find('.product_less,.product_more');
	    }
	    $btn.click(function (ev) {
	      ev.preventDefault();
	      ev.stopPropagation();
	      var $parent = $(this).closest('.grater');
	      var product_id = $parent.data('product_id');
	      var delta = $(this).hasClass('product_more') ? 1 : -1;
	      var $qty = $parent.find('.product_qty__inner');
	      var qty = 0;
	      var multi = [];
	      var new_val = -1;
	      var product_stock_quantity = $parent.data('stock_quantity');
	      //impact on total_qty
	      var total_delta = delta;
	      if (self.type == 'diet') {
	        //get multipliers
	        //can be more than 2
	        self.$cart.find('.multiplier').each(function () {
	          var val = parseInt($(this).text());
	
	          if (this == $qty[0]) {
	            //to jest to pole, ktore zainicjowalo eventy
	            val += delta;
	            new_val = Math.min(7, Math.max(val, 1));
	            val = new_val;
	          }
	          multi.push(val);
	        });
	        qty = multi[0];
	        self.total_qty = qty;
	        total_delta = 0;
	        self.persons_qty = multi[1];
	      } else {
	        if (product_stock_quantity || product_stock_quantity === 0) {
	          if ($qty.text() < product_stock_quantity) {
	            qty = parseInt($parent.find('.multiplier').text()) + delta;
	          } else {
	            qty = $qty.text();
	            if (delta > 0) {
	              total_delta -= 1;
	            } else {
	              qty--;
	            }
	          }
	        } else {
	          qty = parseInt($parent.find('.multiplier').text()) + delta;
	        }
	      }
	      var created = false;
	      self.$cart.removeClass('is-transparent');
	      if (self.products[product_id] == void 0) {
	        created = true;
	        self.createProductRecord(product_id);
	      }
	      var oldVal = self.products[product_id].qty;
	      self.products[product_id].qty = qty; //delta;
	      if (qty <= 0) {
	        if (qty < 0) {
	          total_delta = 0;
	        }
	        self.removeProduct(product_id);
	      } else {
	        if (self.type == 'page') {
	          if (qty > 99) {
	            self.products[product_id].qty = qty = 99;
	            total_delta = 0;
	          }
	        }
	        if (total_delta > 0 && self.isAbonamentCheckout) {
	          if (self.total_qty >= 6) {
	            self.products[product_id].qty = qty = oldVal;
	            total_delta = 0;
	            if (qty == 0) {
	              self.removeProduct(product_id);
	            }
	          }
	        }
	        //update mini cart
	        if (created) {
	          self.rebuildList();
	        } else {
	          var $mini_qty = self.$cart.find('.product_qty_' + product_id);
	          var $mini_price = self.$cart.find('.product_price_' + product_id);
	          $mini_qty.text(qty);
	          $mini_price.html(self.formatPrice(self.products[product_id].price));
	        }
	        if (self.type == 'page') {
	          $qty.text(qty);
	        }
	      }
	      if (self.type == 'diet') {
	        $qty.text(new_val);
	        self.triggerCssAnimationOnElement($qty, 'changed-val');
	      }
	      self.total_qty += total_delta;
	      self.validateMinQty();
	      self.updateSum();
	      self.setQtyInputVal(product_id);
	      if (self.checkQuantity(qty, product_stock_quantity, $(this).parent().children('.product_more'), self)) {
	        self.triggerCssAnimationOnElement($qty, 'changed-val');
	      }
	    });
	    self.$cart.on('click', '.remove', function (ev) {
	      ev.stopPropagation();
	      ev.preventDefault();
	      var pid = $(this).data('product_id');
	      self.removeProduct(pid);
	    });
	    self.$add.click(function (ev) {
	      var $btn = $(ev.currentTarget);
	      if ($btn.hasClass('is-disabled')) {
	        ev.stopPropagation();
	        ev.preventDefault();
	        return;
	      }
	      ev.stopPropagation();
	      ev.preventDefault();
	      var that = self;
	      $btn.addClass('is-disabled');
	      var p = self.products;
	      var ladda = _ladda2.default.create(ev.currentTarget);
	      if (Object.keys(p).length === 0) {
	        if (self.type === 'diet') {
	          p = self.diet_id;
	        } else if (self.type === 'juice_pack') {
	          p = self.juice_pack_id;
	        } else if (self.type === 'upsell') {
	          p = ev.currentTarget.getAttribute('data-product-id');
	        } else {
	          //nie dodalismy produktow
	          return;
	        }
	      }
	      var data = {
	        action: 'custom_add_to_cart',
	        products: p
	      };
	
	      if (self.type == 'diet') {
	        //we have to get
	        var _pq = self.$cart.find('.persons_qty .product_qty__inner').text();
	        data['persons_qty'] = _pq;
	        if ((typeof p === 'undefined' ? 'undefined' : _typeof(p)) == 'object') {
	          p[self.diet_id].qty = p[self.diet_id].qty;
	        }
	      }
	      try {
	        /**
	         * TRACKING
	         */
	        if (window.dataLayer) {
	          window.dataLayer.push({ ecommerce: null });
	          window.dataLayer.push({
	            event: 'add_to_cart',
	            ecommerce: {
	              currency: 'PLN',
	              value: self.getTotalPrice(),
	              items: self.getGoogleProducts()
	            }
	          });
	        }
	        if (window.userengage) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = Object.entries(self.getUserEngageProducts())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var _step$value = _slicedToArray(_step.value, 2),
	                  key = _step$value[0],
	                  val = _step$value[1];
	
	              console.log('user engage');
	              console.log(val);
	              userengage('event.AddToCart', val);
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	      } catch (e) {
	        console.error(e);
	      }
	      _edrone3.default.push(function (_edrone) {
	        _edrone.action_type = 'add_to_cart';
	
	        var data = self.products;
	
	        for (var key in data) {
	          _edrone.product_titles = data[key].title;
	          _edrone.product_counts = data[key].qty;
	          _edrone.product_category_names = data[key].categoryName && data[key].categoryName.length > 0 ? data[key].categoryName : data[key].title;
	
	          if (self.product_category == 'dieta' && typeof pq != 'undefined') {
	            var qty = self.getTotalQty();
	            _edrone.product_titles = data[key].title + ' na ' + qty + ' ' + (qty > 1 ? 'dni' : 'dzień');
	            _edrone.product_counts = pq;
	          }
	
	          _edrone.init();
	        }
	      });
	      if (self.isAbonamentCheckout) {
	        data['abonament'] = window.abonamentQty;
	      }
	      self.$.post(backend.wc_ajax.replace('%%endpoint%%', 'custom_add_to_cart'), data, function (response) {
	        self.replaceFragments(response.fragments);
	        if (self.isAbonamentCheckout) {
	          if (!response.location) {
	            alert('Wystąpił błąd!');
	            return;
	          }
	          window.location.href = response.location;
	          return;
	        }
	
	        $btn.removeClass('is-disabled');
	        ladda.stop();
	        if (typeof response.fragments.missing_juices != 'undefined') {
	          window.missing_juices = response.fragments.missing_juices;
	          for (var i = 0; i < window.carts.length; ++i) {
	            window.carts[i].validateMinQty();
	          }
	          delete response.fragments.missing_juices;
	        }
	
	        self.total_qty = 0;
	        for (var _i in self.products) {
	          if (!self.products.hasOwnProperty(_i)) {
	            continue;
	          }
	          if (self.type == 'diet') {
	            self.products[_i].qty = 1;
	          } else {
	            self.removeProduct(_i);
	          }
	        }
	        if (self.type == 'diet') {
	          self.persons_qty = 1;
	          self.$cart.find('.product_qty .product_qty__inner').text('1');
	          self.updateSum();
	        } else {
	          self.validateMinQty();
	          self.updateSum();
	        }
	        if (self.type == 'upsell') {
	          window.location.reload();
	          return;
	        }
	        /**
	         * Open confirmation dialog
	         */
	        var dlg = new _dialog2.default('<h3>Dzi\u0119kujemy!</h3>' + ('<div class="desc">' + (self.product_category === 'products' ? 'Produkty' : 'Soki') + ' zosta\u0142y dodane do koszyka</div>') + '<div class="buttons">' + '<a class="ghost_button bg_red close_dialog" href="#">Kontynuuj zakupy</a>' + ('<a class="ghost_button bg_red" href="' + window.backend.cart + '">Przejd\u017A do koszyka</a>') + '</div>');
	        dlg.open();
	      });
	      ladda.start();
	    });
	  },
	  createProductRecord: function createProductRecord(product_id) {
	    var $parent = jQuery(".grater[data-product_id='" + product_id + "']");
	    if (this.type == 'juice_pack') {
	      $parent = jQuery(".local_cart[data-product_id='" + product_id + "']");
	    }
	    this.hasProducts = true;
	    this.products[product_id] = {
	      id: product_id,
	      title: $parent.data('product_title'),
	      categoryName: $parent.data('cat_name'),
	      price: $parent.data('product_price'),
	      dynamic_pricing: $parent.data('dynamic_pricing'),
	      qty: 0,
	      omnibus: $parent.data('omnibus')
	    };
	  },
	  formatPrice: function formatPrice(price) {
	    return (parseFloat(price).toFixed(2) + '').replace('.', ',') + ' ' + backend.currency;
	  },
	
	  validateMinQty: function validateMinQty() {
	    var minQty = window.missing_juices;
	
	    if (this.isAbonamentCheckout) {
	      minQty = 6;
	    } else if (minQty == 0) {
	      minQty = 1;
	    }
	    var q = this.total_qty;
	    if (this.type == 'juice_pack' || this.type == 'diet') {
	      return;
	    }
	    var more = minQty - q;
	    if (more <= 0) {
	      this.$cart.find('.not_enough_items').hide();
	      this.$cart.find('.mini_cart__add_to_cart').removeClass('is-disabled');
	    } else {
	      if (minQty > 1) {
	        this.$cart.find('.not_enough_items').show();
	      } else {
	        this.$cart.find('.not_enough_items').hide();
	      }
	      this.$cart.find('.qty').text(more + ' ' + (this.product_category === 'products' ? this.produktyCases(more) : this.sokiCases(more)));
	      this.$cart.find('.mini_cart__add_to_cart').addClass('is-disabled');
	    }
	    if (q == 0) {
	      this.$cart.find('.mini_cart__list').addClass('is-empty');
	    } else {
	      this.$cart.find('.mini_cart__list').removeClass('is-empty');
	    }
	  },
	
	  replaceFragments: function replaceFragments(fragments) {
	    // Replace fragments
	    var self = this;
	    if (fragments) {
	      this.$.each(fragments, function (key, value) {
	        self.$(key).replaceWith(value);
	      });
	    }
	  },
	
	  removeProduct: function removeProduct(pid) {
	    this.products[pid].qty = 0;
	    this.setQtyInputVal(pid);
	    delete this.products[pid]; //.qty = 0;
	    this.$(".grater[data-product_id='" + pid + "'] .product_qty__inner").html(0);
	    this.rebuildList();
	  },
	
	  sokiCases: function sokiCases(qty) {
	    var $number = '';
	    if (qty == 1) {
	      $number = 'sok';
	    } else if (qty >= 5) {
	      $number = 'soków';
	    } else {
	      $number = 'soki';
	    }
	    return $number;
	  },
	
	  produktyCases: function produktyCases(qty) {
	    var $number = '';
	    if (qty == 1) {
	      $number = 'produkt';
	    } else if (qty >= 5) {
	      $number = 'produktów';
	    } else {
	      $number = 'produkty';
	    }
	    return $number;
	  },
	
	  setQtyInputVal: function setQtyInputVal(pid) {
	    //this.$("input[name='product_qty["+pid+"]']").val(this.products[pid].qty);
	  },
	
	  rebuildList: function rebuildList() {
	    if (this.type != 'page') {
	      return;
	    }
	    this.$cart.find('.mini_cart__list').html(this.createCartRecords());
	  },
	
	  triggerCssAnimationOnElement: function triggerCssAnimationOnElement(t, e) {
	    return t.removeClass(e), t.hide().show(0), t.addClass(e);
	  },
	
	  createCartRecords: function createCartRecords() {
	    var _this = this;
	
	    if (this.type != 'page') {
	      return;
	    }
	    var html = '';
	    Object.keys(this.products).forEach(function (id) {
	      var i = _this.products[id];
	      html += '\n<li class="mini_cart__record" data-product_id="' + i.id + '">\n    <input type="hidden" name="product_qty[' + i.id + ']" value="' + i.qty + '">\n    <div>\n      <div>\n        <a class="title open_product_popup" data-product_id="' + i.id + '" href="#">\n            ' + i.title + '\n        </a>\n        <div class="break"></div>\n        <div class="right">\n            <span class="quantity_wrap"><span class="quantity product_qty_' + i.id + '">' + i.qty + '</span>x</span>\n            <span class="price product_price_i.id\'">' + _this.formatPrice(_this.calculatePrice(i, 1)) + '</span>\n        </div>\n      </div>\n      ' + i.omnibus + '\n    </div>\n</li>';
	    });
	    return html;
	  },
	
	  calculatePrice: function calculatePrice(item, force_qty) {
	    return this.dynamicPrice(item, force_qty);
	  },
	
	  dynamicPrice: function dynamicPrice(item, force_qty) {
	    var qty = item.qty;
	
	    if (typeof force_qty != 'undefined') {
	      qty = force_qty;
	    }
	
	    var val = item.price * qty;
	    if (item['dynamic_pricing'] == void 0 || item['dynamic_pricing'][qty] == void 0) {
	      //normal pricing
	    } else {
	      val = item['dynamic_pricing'][qty];
	    }
	    if (this.type == 'diet') {
	      val = this.persons_qty * val;
	    }
	    return parseFloat(val);
	  },
	  getProductsForAnalytics: function getProductsForAnalytics() {
	    if (window.abonamentQty) {
	      var p = window.abonamentProduct;
	      var data = {};
	      data[p.id] = {
	        id: p.id,
	        title: p.post.post_title,
	        categoryName: 'Abonament',
	        price: p.price,
	        qty: 1,
	        juices: {}
	      };
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = Object.entries(this.products)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var _step2$value = _slicedToArray(_step2.value, 2),
	              key = _step2$value[0],
	              val = _step2$value[1];
	
	          data[p.id].juices[key] = {
	            id: key,
	            title: val.title
	          };
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return data;
	    }
	    if (!this.hasProducts) {
	      if (this.type == 'diet') {
	        this.createProductRecord(this.diet_id);
	        this.products[this.diet_id].qty = 1;
	        this.persons_qty = 1;
	      } else if (this.type == 'juice_pack') {
	        this.createProductRecord(this.juice_pack_id);
	        this.products[this.juice_pack_id].qty = 1;
	      }
	    }
	    return this.products;
	  },
	  getFacebookNames: function getFacebookNames() {
	    var ret = [];
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      for (var _iterator3 = Object.entries(this.getProductsForAnalytics())[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var _step3$value = _slicedToArray(_step3.value, 2),
	            id = _step3$value[0],
	            product = _step3$value[1];
	
	        ret.push(product.title);
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3.return) {
	          _iterator3.return();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	
	    return ret.join(', ');
	  },
	  getFacebookIds: function getFacebookIds() {
	    var ret = [];
	    var _iteratorNormalCompletion4 = true;
	    var _didIteratorError4 = false;
	    var _iteratorError4 = undefined;
	
	    try {
	      for (var _iterator4 = Object.entries(this.getProductsForAnalytics())[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	        var _step4$value = _slicedToArray(_step4.value, 2),
	            id = _step4$value[0],
	            product = _step4$value[1];
	
	        ret.push(parseInt(id));
	      }
	    } catch (err) {
	      _didIteratorError4 = true;
	      _iteratorError4 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion4 && _iterator4.return) {
	          _iterator4.return();
	        }
	      } finally {
	        if (_didIteratorError4) {
	          throw _iteratorError4;
	        }
	      }
	    }
	
	    return ret;
	  },
	  getFacebookProducts: function getFacebookProducts() {
	    var ret = [];
	    var _iteratorNormalCompletion5 = true;
	    var _didIteratorError5 = false;
	    var _iteratorError5 = undefined;
	
	    try {
	      for (var _iterator5 = Object.entries(this.getProductsForAnalytics())[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	        var _step5$value = _slicedToArray(_step5.value, 2),
	            id = _step5$value[0],
	            product = _step5$value[1];
	
	        var data = {
	          id: id,
	          title: product.title,
	          qty: product.qty
	        };
	        if (this.type == 'diet') {
	          data.persons_qty = this.persons_qty;
	        }
	        ret.push(data);
	      }
	    } catch (err) {
	      _didIteratorError5 = true;
	      _iteratorError5 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion5 && _iterator5.return) {
	          _iterator5.return();
	        }
	      } finally {
	        if (_didIteratorError5) {
	          throw _iteratorError5;
	        }
	      }
	    }
	
	    return ret;
	  },
	  getGoogleProducts: function getGoogleProducts() {
	    var ret = [];
	    var _iteratorNormalCompletion6 = true;
	    var _didIteratorError6 = false;
	    var _iteratorError6 = undefined;
	
	    try {
	      for (var _iterator6 = Object.entries(this.getProductsForAnalytics())[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	        var _step6$value = _slicedToArray(_step6.value, 2),
	            id = _step6$value[0],
	            product = _step6$value[1];
	
	        ret.push({
	          item_id: id,
	          item_name: product.title + (this.type == 'diet' ? '(dni: ' + product.qty + ')' : ''),
	          price: product.price,
	          currency: 'PLN',
	          quantity: this.type == 'diet' ? this.persons_qty : product.qty
	        });
	      }
	    } catch (err) {
	      _didIteratorError6 = true;
	      _iteratorError6 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion6 && _iterator6.return) {
	          _iterator6.return();
	        }
	      } finally {
	        if (_didIteratorError6) {
	          throw _iteratorError6;
	        }
	      }
	    }
	
	    return ret;
	  },
	  getUserEngageProducts: function getUserEngageProducts() {
	    var ret = [];
	    var _iteratorNormalCompletion7 = true;
	    var _didIteratorError7 = false;
	    var _iteratorError7 = undefined;
	
	    try {
	      for (var _iterator7 = Object.entries(this.getProductsForAnalytics())[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	        var _step7$value = _slicedToArray(_step7.value, 2),
	            id = _step7$value[0],
	            product = _step7$value[1];
	
	        var data = {
	          pid: id,
	          title: product.title,
	          quantity: this.type == 'diet' ? this.persons_qty : product.qty,
	          price: product.price,
	          type: this.type
	        };
	        if (this.type == 'diet') {
	          data.days = product.qty;
	        }
	        if (product.juices) {
	          data.type = 'abonament';
	          data.juices = JSON.stringify(product.juices);
	        }
	        if (!data.days) {
	          data.days = 1;
	        }
	        data.sum = data.days * data.quantity * data.price;
	        ret.push(data);
	      }
	    } catch (err) {
	      _didIteratorError7 = true;
	      _iteratorError7 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion7 && _iterator7.return) {
	          _iterator7.return();
	        }
	      } finally {
	        if (_didIteratorError7) {
	          throw _iteratorError7;
	        }
	      }
	    }
	
	    return ret;
	  },
	  getTotalQty: function getTotalQty() {
	    if (!this.hasProducts) {
	      if (this.type == 'diet' || this.type == 'juice_pack') {
	        return 1;
	      }
	      return 0;
	    }
	    var val = 0;
	    for (var id in this.products) {
	      if (this.products.hasOwnProperty(id) == false) {
	        continue;
	      }
	      val += this.products[id].qty;
	    }
	    return val;
	  },
	  getTotalPrice: function getTotalPrice() {
	    var val = 0;
	
	    if (!this.hasProducts) {
	      if (this.type == 'diet') {
	        this.createProductRecord(this.diet_id);
	        this.products[this.diet_id].qty = 1;
	        this.persons_qty = 1;
	      } else if (this.type == 'juice_pack') {
	        this.createProductRecord(this.juice_pack_id);
	        this.products[this.juice_pack_id].qty = 1;
	      }
	    }
	    for (var id in this.products) {
	      val += this.calculatePrice(this.products[id]);
	    }
	
	    return val;
	  },
	  checkQuantity: function checkQuantity(qty, max_qty, el, context) {
	    if (!max_qty) {
	      return true;
	    }
	
	    if (qty < max_qty) {
	      $(el).removeClass('-max');
	      return true;
	    } else {
	      $(el).addClass('-max');
	      context.triggerCssAnimationOnElement($(el).parent().find('.product_qty__inner'), 'changed-val');
	    }
	  },
	  updateSum: function updateSum() {
	    var val = this.getTotalPrice();
	    if (this.type == 'diet' && Object.keys(this.products).length > 0) {
	      var p = this.products[Object.keys(this.products)[0]];
	      var dp = this.dynamicPrice(p) / this.persons_qty;
	      var singlep = this.dynamicPrice(p, 1);
	
	      this.$cart.closest('.bundle').find('.bundle__price .amount').html(this.formatPrice(dp / p.qty) + (this.persons_qty > 1 ? ' * ' + this.persons_qty : ''));
	      var savings = singlep * p.qty - dp * this.persons_qty;
	      if (savings > 0) {
	        this.$cart.closest('.bundle').find('.bundle__price .savings').html('Oszczędzasz ' + this.formatPrice(singlep * p.qty - dp));
	      } else {
	        this.$cart.closest('.bundle').find('.bundle__price .savings').text('');
	      }
	    }
	    this.$cart.find('.mini_cart__total_val').html(this.formatPrice(val));
	  }
	});
	(function ($) {
	  //add hooks
	  window.carts = [];
	  $('.local_cart').each(function () {
	    var c = new LocalCart($, $(this));
	    window.carts.push(c);
	  });
	})(jQuery);
	exports.default = {
	  create: function create(el) {
	    var c = new LocalCart($, $(el));
	    window.carts.push(c);
	  }
	};

/***/ }),

/***/ 351:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var initPhotoSwipeFromDOM = function initPhotoSwipeFromDOM(gallerySelector) {
	
	    // parse slide data (url, title, size ...) from DOM elements
	    // (children of gallerySelector)
	    var parseThumbnailElements = function parseThumbnailElements(el) {
	        var thumbElements = el.childNodes,
	            numNodes = thumbElements.length,
	            items = [],
	            figureEl,
	            linkEl,
	            size,
	            item;
	
	        for (var i = 0; i < numNodes; i++) {
	
	            figureEl = thumbElements[i]; // <figure> element
	
	            // include only element nodes
	            if (figureEl.nodeType !== 1) {
	                continue;
	            }
	
	            linkEl = figureEl.children[0]; // <a> element
	
	            size = linkEl.getAttribute('data-size').split('x');
	
	            // create slide object
	            item = {
	                src: linkEl.getAttribute('href'),
	                w: parseInt(size[0], 10),
	                h: parseInt(size[1], 10)
	            };
	
	            if (figureEl.children.length > 1) {
	                // <figcaption> content
	                item.title = figureEl.children[1].innerHTML;
	            }
	
	            if (linkEl.children.length > 0) {
	                // <img> thumbnail element, retrieving thumbnail url
	                item.msrc = linkEl.children[0].getAttribute('src');
	            }
	
	            item.el = figureEl; // save link to element for getThumbBoundsFn
	            items.push(item);
	        }
	
	        return items;
	    };
	
	    // find nearest parent element
	    var closest = function closest(el, fn) {
	        return el && (fn(el) ? el : closest(el.parentNode, fn));
	    };
	
	    // triggers when user clicks on thumbnail
	    var onThumbnailsClick = function onThumbnailsClick(e) {
	        e = e || window.event;
	        e.preventDefault ? e.preventDefault() : e.returnValue = false;
	
	        var eTarget = e.target || e.srcElement;
	
	        // find root element of slide
	        var clickedListItem = closest(eTarget, function (el) {
	            return el.tagName && el.tagName.toUpperCase() === 'FIGURE';
	        });
	
	        if (!clickedListItem) {
	            return;
	        }
	
	        // find index of clicked item by looping through all child nodes
	        // alternatively, you may define index via data- attribute
	        var clickedGallery = clickedListItem.parentNode,
	            childNodes = clickedListItem.parentNode.childNodes,
	            numChildNodes = childNodes.length,
	            nodeIndex = 0,
	            index;
	
	        for (var i = 0; i < numChildNodes; i++) {
	            if (childNodes[i].nodeType !== 1) {
	                continue;
	            }
	
	            if (childNodes[i] === clickedListItem) {
	                index = nodeIndex;
	                break;
	            }
	            nodeIndex++;
	        }
	
	        if (index >= 0) {
	            // open PhotoSwipe if valid index found
	            openPhotoSwipe(index, clickedGallery);
	        }
	        return false;
	    };
	
	    // parse picture index and gallery index from URL (#&pid=1&gid=2)
	    var photoswipeParseHash = function photoswipeParseHash() {
	        var hash = window.location.hash.substring(1),
	            params = {};
	
	        if (hash.length < 5) {
	            return params;
	        }
	
	        var vars = hash.split('&');
	        for (var i = 0; i < vars.length; i++) {
	            if (!vars[i]) {
	                continue;
	            }
	            var pair = vars[i].split('=');
	            if (pair.length < 2) {
	                continue;
	            }
	            params[pair[0]] = pair[1];
	        }
	
	        if (params.gid) {
	            params.gid = parseInt(params.gid, 10);
	        }
	
	        return params;
	    };
	
	    var openPhotoSwipe = function openPhotoSwipe(index, galleryElement, disableAnimation, fromURL) {
	        var pswpElement = document.querySelectorAll('.pswp')[0],
	            gallery,
	            options,
	            items;
	
	        items = parseThumbnailElements(galleryElement);
	
	        // define options (if needed)
	        options = {
	
	            // define gallery index (for URL)
	            galleryUID: galleryElement.getAttribute('data-pswp-uid'),
	
	            getThumbBoundsFn: function getThumbBoundsFn(index) {
	                // See Options -> getThumbBoundsFn section of documentation for more info
	                var thumbnail = items[index].el.getElementsByTagName('img')[0],
	                    // find thumbnail
	                pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
	                    rect = thumbnail.getBoundingClientRect();
	
	                return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
	            }
	
	        };
	
	        // PhotoSwipe opened from URL
	        if (fromURL) {
	            if (options.galleryPIDs) {
	                // parse real index when custom PIDs are used
	                // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
	                for (var j = 0; j < items.length; j++) {
	                    if (items[j].pid == index) {
	                        options.index = j;
	                        break;
	                    }
	                }
	            } else {
	                // in URL indexes start from 1
	                options.index = parseInt(index, 10) - 1;
	            }
	        } else {
	            options.index = parseInt(index, 10);
	        }
	
	        // exit if index not found
	        if (isNaN(options.index)) {
	            return;
	        }
	
	        if (disableAnimation) {
	            options.showAnimationDuration = 0;
	        }
	
	        // Pass data to PhotoSwipe and initialize it
	        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
	        gallery.init();
	    };
	
	    // loop through all gallery elements and bind events
	    var galleryElements = document.querySelectorAll(gallerySelector);
	
	    for (var i = 0, l = galleryElements.length; i < l; i++) {
	        galleryElements[i].setAttribute('data-pswp-uid', i + 1);
	        galleryElements[i].onclick = onThumbnailsClick;
	    }
	
	    // Parse URL and open gallery if it contains #&pid=3&gid=1
	    var hashData = photoswipeParseHash();
	    if (hashData.pid && hashData.gid) {
	        openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
	    }
	};
	exports.default = initPhotoSwipeFromDOM;

/***/ }),

/***/ 352:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function WcQuantity(el) {
	    this.$el = $(el);
	    this.val = parseInt($(el).attr("value"));
	    this.step = parseInt($(el).attr("step"));
	    this.min = parseInt($(el).attr("min"));
	    this.max = parseInt($(el).attr("max"));
	    $(el).find("a").click(function (ev) {
	        ev.preventDefault();
	    });
	}
	WcQuantity.prototype.updateVal = function (val) {
	    if (val < this.min) {
	        val = this.min;
	    }
	    if (val > this.max) {
	        val = this.max;
	    }
	    this.val = val;
	    this.$el.find("input").val(val);
	    this.$el.find(".quantity_val").text(val);
	};
	exports.default = WcQuantity;

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _desc, _value, _class;
	
	var _autobindDecorator = __webpack_require__(97);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	    var desc = {};
	    Object['ke' + 'ys'](descriptor).forEach(function (key) {
	        desc[key] = descriptor[key];
	    });
	    desc.enumerable = !!desc.enumerable;
	    desc.configurable = !!desc.configurable;
	
	    if ('value' in desc || desc.initializer) {
	        desc.writable = true;
	    }
	
	    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	        return decorator(target, property, desc) || desc;
	    }, desc);
	
	    if (context && desc.initializer !== void 0) {
	        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	        desc.initializer = undefined;
	    }
	
	    if (desc.initializer === void 0) {
	        Object['define' + 'Property'](target, property, desc);
	        desc = null;
	    }
	
	    return desc;
	}
	
	var transition = null;
	var Transition = (_class = function () {
	    function Transition(el) {
	        _classCallCheck(this, Transition);
	
	        if (!transition) {
	            Transition.detectTransition();
	        }
	        this.transitions = {};
	        this.$el = $(el);
	        this.count = 0;
	    }
	
	    _createClass(Transition, [{
	        key: 'push',
	        value: function push(css) {
	            var useTransitionEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	            return this._add('push', css, useTransitionEnd);
	        }
	    }, {
	        key: 'pop',
	        value: function pop(css) {
	            var useTransitionEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	            return this._add('pop', css, useTransitionEnd);
	        }
	    }, {
	        key: '_add',
	        value: function _add(type, css, useTransitionEnd) {
	            var _this = this;
	
	            var push = type == 'push';
	            var key = type + '-' + css;
	            var hasClass = this.$el.hasClass(css);
	
	            if (this._pushes(css) || this._poppes(css)) {
	                return new Promise(function (resolve, reject) {
	                    return reject();
	                });
	            }
	            // XOR
	            if (hasClass == push) {
	                //1. hasClass and is pushing
	                //2. doesn't have class and is popping
	                return new Promise(function (resolve, reject) {
	                    return resolve();
	                });
	            }
	            console.log(key, useTransitionEnd);
	
	            var p = new Promise(function (resolve, reject) {
	                _this.count++;
	                _this.transitions[key] = p;
	                var handleTransitionEnd = function handleTransitionEnd() {
	                    _this.count--;
	                    _this.$el.off(transition, handleTransitionEnd);
	                    if (_this.count <= 0) {
	                        _this.$el.removeClass('is-transitioning');
	                    }
	                    if (push) {
	                        _this.$el.removeClass('before-' + css);
	                    } else {
	                        _this.$el.removeClass('after-' + css);
	                    }
	                    delete _this.transitions[key];
	                    resolve();
	                };
	                _this.$el.addClass('is-transitioning');
	                if (push) {
	                    _this.$el.addClass('before-' + css);
	                } else {
	                    _this.$el.addClass('after-' + css);
	                }
	                if (useTransitionEnd) {
	                    _this.$el.on(transition, handleTransitionEnd);
	                }
	                _this.repaint();
	                _this.$el[push ? 'addClass' : 'removeClass'](css);
	                if (!useTransitionEnd) {
	                    handleTransitionEnd();
	                }
	            });
	            return p;
	        }
	    }, {
	        key: 'repaint',
	        value: function repaint() {
	            this.$el[0].offsetHeight;
	        }
	    }, {
	        key: '_pushes',
	        value: function _pushes(css) {
	            return this.transitions['push-' + css] !== undefined;
	        }
	    }, {
	        key: '_poppes',
	        value: function _poppes(css) {
	            return this.transitions['pop-' + css] !== undefined;
	        }
	    }, {
	        key: 'handleTransitionEnd',
	        value: function handleTransitionEnd() {
	            this.$el.removeClass('is-transitioning');
	        }
	    }], [{
	        key: 'detectTransition',
	        value: function detectTransition() {
	            var transitions = {
	                'transition': 'transitionend',
	                'WebkitTransition': 'webkitTransitionEnd',
	                'MozTransition': 'transitionend',
	                'OTransition': 'oTransitionEnd otransitionend'
	            };
	
	            for (var t in transitions) {
	                if (document.body.style[t] !== undefined) {
	                    transition = transitions[t];
	                    break;
	                }
	            }
	        }
	    }]);
	
	    return Transition;
	}(), (_applyDecoratedDescriptor(_class.prototype, 'handleTransitionEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTransitionEnd'), _class.prototype)), _class);
	exports.default = Transition;

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _dialog = __webpack_require__(69);
	
	var _dialog2 = _interopRequireDefault(_dialog);
	
	__webpack_require__(343);
	
	var _pswpUtils = __webpack_require__(351);
	
	var _pswpUtils2 = _interopRequireDefault(_pswpUtils);
	
	var _wc_quantity = __webpack_require__(352);
	
	var _wc_quantity2 = _interopRequireDefault(_wc_quantity);
	
	var _cookies = __webpack_require__(349);
	
	var _cookies2 = _interopRequireDefault(_cookies);
	
	var _utils = __webpack_require__(48);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _edrone2 = __webpack_require__(137);
	
	var _edrone3 = _interopRequireDefault(_edrone2);
	
	var _register = __webpack_require__(375);
	
	var _register2 = _interopRequireDefault(_register);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.breakpoints = {
	    xlarge: 1200,
	    large: 1024,
	    medium: 720,
	    small: 320
	};
	
	window.Dialog = _dialog2.default;
	
	(function ($, root, undefined) {
	    $(document).on('signup', function (e) {
	
	        var emails = e.mail;
	
	        _edrone3.default.push(function (_edrone) {
	            emails.forEach(function (address) {
	                if (typeof _edrone != 'undefined') {
	
	                    _edrone.action_type = 'subscribe';
	                    _edrone.email = address;
	                    _edrone.subscriber_status = '1';
	                    _edrone.init();
	                }
	            });
	        });
	    });
	    $(document).ready(function () {
	        if (window.location.hash) {
	            var scroll = function scroll() {
	                var hash = window.location.hash.match(/^\#(?:[a-zA-Z]+_)(\d+)/);
	                hash = (typeof hash === "undefined" ? "undefined" : _typeof(hash)) == 'object' ? hash[1] : window.location.hash.substring(1);
	                var $navWrap = $('.nav-wrap.header-nav'),
	                    $target = $("#product_" + hash),
	                    $prod = $("[data-product_id='" + hash + "']");
	
	                if (!$target.length) {
	                    $target = $prod;
	                } else if (!$target.length) {
	                    return;
	                }
	
	                $('html, body').animate({
	                    scrollTop: $target.offset().top - $navWrap.height() - 90
	                }, 500);
	            };
	            scroll();
	            $(window).load(scroll);
	        }
	
	        $(".user_nav .toggle").click(function (ev) {
	            ev.stopPropagation();
	            $(".user_nav__popup").toggleClass("is-active");
	        });
	
	        $("body").on("click", ".switcher button", function (ev) {
	            var id = $(this).data("for");
	            $(".switcher_content").not("#" + id).hide();
	            $(".switcher_content#" + id).show();
	            $(".switcher button").removeClass("active");
	            $(this).addClass("active");
	        });
	        //Ladda.bind('.ladda-button');
	        $(".footer .nav_left .menu>.menu-item>a").click(function (ev) {
	            ev.preventDefault();
	            ev.stopPropagation();
	        });
	        (0, _pswpUtils2.default)('.pswp-gallery');
	
	        $(".account-form").on('submit', function (ev) {
	
	            console.log(ev);
	            var form = ev.delegateTarget;
	            _utils2.default.putSpinnerOn($(form));
	
	            var $err_wrap = $(form).find('.error_wrap');
	            $err_wrap.text('');
	            _utils2.default.fetchJson(form.getAttribute('action'), new FormData(ev.delegateTarget), "POST").then(function (json) {
	                console.log(json);
	                _utils2.default.disableSpinner();
	                if (json.status != 'success') {
	                    console.log(json.errors);
	                    for (var _i = 0; _i < json.errors.length; _i++) {
	                        var e = json.errors[_i];
	
	                        if (e.invalid_email || e.incorrect_email) {
	                            var message = e.incorrect_email ? e.incorrect_email : e.invalid_email;
	                            $(form).find('#register_error_reg_email').text(message);
	                        }
	                        if (e.reg_email) {
	                            form.querySelector("#register_error_reg_email").innerHTML = e.reg_email;
	                        }
	                        if (e.invalid_password || e.incorrect_password) {
	                            form.querySelector("#register_error_reg_password").innerHTML = e.incorrect_password ? e.incorrect_password : e.invalid_password;
	                        }
	                        if (e.terms) {
	                            form.querySelector("#register_error_terms").innerHTML = e.terms;
	                        }
	                    }
	                } else {
	                    window.location.href = json.redirect;
	                }
	            });
	            ev.preventDefault();
	        });
	        /* //HACK// */
	        $(".wsafp-form .button").removeClass("button").addClass("bg_red ghost_button");
	
	        //
	        $(".open_cart").click(function (ev) {
	            if ($(".nav_cart__counter").hasClass("is-empty")) {
	
	                var dlg = new _dialog2.default(empty_cart_popup);
	                dlg.toggle();
	                //$("#somedialog").attr("notice-popup","true");
	                //dlg.setBody();
	                ev.stopPropagation();
	                ev.preventDefault();
	                return false;
	            }
	        });
	    });
	    $(function () {
	        if (window.matchMedia("(min-width: 769px)").matches) {
	
	            var $cart = $(".sticky_cart"),
	                bottomSpacing = void 0;
	            if ($cart.is('.mini_cart')) {
	
	                var $cat = $('.categories_row');
	                bottomSpacing = $(document).height() - ($cat.height() + $cat.offset().top);
	            } else {
	                bottomSpacing = $(".footer_wrap").outerHeight();
	            }
	
	            $cart.sticky({
	                topSpacing: 110,
	                bottomSpacing: bottomSpacing + 30
	            });
	        }
	    });
	
	    $(".language_chooser").click(function (ev) {
	        if ($(ev.target).parent().closest('.language_chooser__popup').length > 0) {
	            return;
	        }
	        $(".language_chooser").toggleClass("active");
	    });
	    $("#contact_person_check").change(function () {
	        $(".contact_person_fields").toggleClass("hidden");
	    });
	    $(".vc_toggle").click(function () {
	        if ($(this).hasClass("vc_toggle_active")) {
	            $(this).removeClass("vc_toggle_rotate_arrow");
	        } else {
	            $(this).addClass("vc_toggle_rotate_arrow");
	        }
	    });
	    $(document.body).on("added_to_cart", function () {
	        checkCartIsEmpty();
	    });
	    $(".menu-toggle").click(function () {
	        $(this).find(".hamburger").toggleClass("is-active");
	        $(".menu").toggleClass("is-active");
	        $("body").toggleClass("menu-open");
	    });
	    $("body").on("click", ".open_product_popup", function (ev) {
	        ev.stopPropagation();
	        ev.preventDefault();
	
	        var dlg = new _dialog2.default(somedialog);
	        dlg.toggle();
	        $("#somedialog").addClass("is-empty");
	        $("#somedialog .dialog__content__body").html("");
	        var pid = $(this).data("product_id");
	        $.post(backend.ajax, {
	            action: 'get_product_popup',
	            product_id: pid
	        }, function (response) {
	            $("#somedialog").removeClass("is-empty");
	            dlg.setBody(response);
	        });
	    });
	    var $dialogs = $(".dialog.open-now");
	    for (var i = 0; i < $dialogs.length; ++i) {
	        var dlg = new _dialog2.default($dialogs[i]);
	    }
	    $(".wc_quantity").each(function () {
	        var self = this;
	        new _wc_quantity2.default(this);
	    });
	    $("#do_company").change(function () {
	        if ($(this).prop('checked')) {
	            $("body").addClass("do_company");
	            $(".company_fields__inner input").removeAttr("disabled");
	        } else {
	            $("body").removeClass("do_company");
	            $(".company_fields__inner input").attr("disabled", "disabled");
	        }
	    });
	
	    $("a.product_less").on('click', function (ev) {
	        var $thisbutton = $(this);
	        if (!$thisbutton.attr('data-product_id')) {
	            return true;
	        }
	
	        $thisbutton.removeClass('added');
	        $thisbutton.addClass('loading');
	
	        var data = {};
	
	        $.each($thisbutton.data(), function (key, value) {
	            data[key] = value;
	        });
	        // Trigger event
	        $(document.body).trigger('adding_to_cart', [$thisbutton, data]);
	
	        ev.stopPropagation();
	        ev.preventDefault();
	        $.post(backend.decrement_quantity, {
	            action: 'decrement_quantity',
	            product_id: $(this).attr("data-product_id")
	        }, function (response) {
	
	            console.log(response);
	            if (!response) {
	                return;
	            }
	
	            var this_page = window.location.toString();
	
	            this_page = this_page.replace('add-to-cart', 'added-to-cart');
	
	            if (response.error && response.product_url) {
	                window.location = response.product_url;
	                return;
	            }
	
	            // Redirect to cart option
	            if (wc_add_to_cart_params.cart_redirect_after_add === 'yes') {
	
	                window.location = wc_add_to_cart_params.cart_url;
	                return;
	            } else {
	
	                $thisbutton.removeClass('loading');
	
	                var fragments = response.fragments;
	                var cart_hash = response.cart_hash;
	
	                // Block fragments class
	                if (fragments) {
	                    $.each(fragments, function (key) {
	                        $(key).addClass('updating');
	                    });
	                }
	
	                // Block widgets and fragments
	                $('.shop_table.cart, .updating, .cart_totals').fadeTo('400', '0.6').block({
	                    message: null,
	                    overlayCSS: {
	                        opacity: 0.6
	                    }
	                });
	
	                // Changes button classes
	                $thisbutton.addClass('added');
	
	                // View cart text
	                if (!wc_add_to_cart_params.is_cart && $thisbutton.parent().find('.added_to_cart').size() === 0) {
	                    $thisbutton.after(' <a href="' + wc_add_to_cart_params.cart_url + '" class="added_to_cart wc-forward" title="' + wc_add_to_cart_params.i18n_view_cart + '">' + wc_add_to_cart_params.i18n_view_cart + '</a>');
	                }
	
	                replaceFragments(fragments);
	                // Unblock
	                $('.widget_shopping_cart, .updating').stop(true).css('opacity', '1').unblock();
	
	                // Cart page elements
	                $('.shop_table.cart').load(this_page + ' .shop_table.cart:eq(0) > *', function () {
	
	                    $('.shop_table.cart').stop(true).css('opacity', '1').unblock();
	
	                    $(document.body).trigger('cart_page_refreshed');
	                });
	
	                $('.cart_totals').load(this_page + ' .cart_totals:eq(0) > *', function () {
	                    $('.cart_totals').stop(true).css('opacity', '1').unblock();
	                });
	
	                // Trigger event so themes can refresh other areas
	                $(document.body).trigger('added_to_cart', [fragments, cart_hash, $thisbutton]);
	            }
	        });
	    });
	
	    var getQueryString = function getQueryString(str) {
	        str = str.substr(str.indexOf('?') + 1);
	        return (str || document.location.search).replace(/(^\?)/, '').split("&").map(function (n) {
	            return n = n.split("="), this[n[0]] = n[1], this;
	        }.bind({}))[0];
	    };
	
	    $("body").on("click", ".mini_cart_item .remove", function (ev) {
	        var url = $(this).attr("href");
	        ev.preventDefault();
	        ev.stopPropagation();
	        var data = {
	            action: 'remove_from_cart'
	        };
	        data = $.extend(data, getQueryString(url));
	        console.log(data);
	        $.post(backend.decrement_quantity, data, function (response) {
	
	            var fragments = response.fragments;
	            var cart_hash = response.cart_hash;
	            var $thisbutton = $(this);
	            replaceFragments(fragments);
	            // Trigger event so themes can refresh other areas
	            $(document.body).trigger('added_to_cart', [fragments, cart_hash, $thisbutton]);
	        });
	    });
	    function replaceFragments(fragments) {
	        // Replace fragments
	        if (fragments) {
	            $.each(fragments, function (key, value) {
	                $(key).replaceWith(value);
	            });
	        }
	    }
	})(jQuery, undefined);

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

	"use strict";
	
	function Diet($, $obj) {
	    if (this == window) {
	        return new Diet($, $obj);
	    }
	    var self = this;
	    this.$obj = $obj;
	    this.$ = $;
	    this.$juices = $obj.find(".open_product_popup");
	    this.$caption = $obj.find(".bundle__juice_caption");
	    $obj.on("mouseover", ".open_product_popup", function () {
	        self.highlightStart(this);
	    });
	    $obj.on("mouseout", ".open_product_popup", function () {
	        self.highlightOver(this);
	    });
	    return this;
	};
	Diet.prototype.highlightStart = function (img) {
	    this.$juices.not(img).addClass("dim");
	    this.$(img).addClass("active");
	    this.$caption.addClass("active").html(this.$(img).data("product_name") + '<span class="skladniki"> - ' + this.$(img).data("ingredients") + '</span>');
	};
	Diet.prototype.highlightOver = function () {
	    this.$caption.removeClass("active");
	    this.$juices.removeClass("dim").removeClass("active");
	};
	
	(function ($) {
	    //add hooks
	    $(".bundle").each(function () {
	        new Diet($, $(this));
	
	        var btn = $(this).find('.info_toggle'),
	            desc = $(this).find('.diet__description');
	
	        btn.click(function () {
	            desc.toggleClass('open');
	        });
	    });
	})(jQuery);

/***/ }),

/***/ 369:
/***/ (function(module, exports) {

	'use strict';
	
	$(window).load(function () {
	  var hash = window.location.hash;
	  console.log('test');
	
	  if (hash.includes('#product_')) {
	    var $productEl = $(hash);
	    var productId = hash.split('_')[1];
	
	    if ($productEl.length === 0) {
	      $productEl = $('.post-' + productId);
	
	      if ($productEl.length > 0) {
	        goToSpecificDiet($productEl, true);
	      }
	    } else {
	      goToSpecificDiet($productEl);
	    }
	  }
	
	  function goToSpecificDiet($productEl) {
	    var openPopup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    $('html, body').animate({
	      scrollTop: $productEl.offset().top - 200
	    }, 1500, function () {
	      if (openPopup) {
	        $productEl.children(":first").trigger('click');
	      }
	    });
	  };
	});

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var spinnerTimeout = null,
	    opacityTimeout = null;
	var loadedScripts = [];
	var spinnerStartTime = 0;
	/**
	 * Remove by value
	 * @returns {Array}
	 */
	Array.prototype.remove = function () {
	    var what = void 0,
	        a = arguments,
	        L = a.length,
	        ax = void 0;
	    while (L && this.length) {
	        what = a[--L];
	        while ((ax = this.indexOf(what)) !== -1) {
	            this.splice(ax, 1);
	        }
	    }
	    return this;
	};
	if (window.Element) {
	    Element.prototype.render = function () {
	        "use strict";
	
	        this.offsetHeight;
	        return this;
	    };
	}
	
	function _doDisableSpinner() {
	    var $spin = $(".cart_item_loader");
	    if (!$spin) {
	        return;
	    }
	    $spin.css({ "opacity": 0 })[0].render();
	    spinnerTimeout = setTimeout(function () {
	        spinnerTimeout = null;
	        $spin.hide();
	    }, 400);
	}
	var Utils = {
	    fetchJson: function fetchJson(url, query, method) {
	        if (method === undefined) {
	            method = "GET";
	        }
	        var conf = { method: method, credentials: 'same-origin' };
	        if (method == "POST") {
	            if (query instanceof FormData) {
	                conf.body = query;
	            } else {
	
	                var data = new FormData();
	                Object.keys(query).map(function (k) {
	                    return "" + data.append(k, query[k]);
	                });
	                conf.body = data;
	            }
	        } else {
	            if (query && method == "GET") {
	                url += '?' + Object.keys(query).map(function (k) {
	                    return encodeURIComponent(k) + "=" + encodeURIComponent(query[k]);
	                }).join('&');
	            }
	        }
	        return fetch(url, conf).then(function (response) {
	            if (response.status >= 200 && response.status < 300) {
	                return response;
	            } else {
	                var error = new Error(response.statusText);
	                error.response = response;
	                throw error;
	            }
	        }).then(function (promise) {
	            var json = promise.json();
	            if (json['error'] !== undefined) {
	                alert("Promise failed: " + json['error']);
	            }
	            return json;
	        });
	    },
	    dietCases: function dietCases(more) {
	        var number = '';
	        if (more == 1) {
	            number = 'dzień diety';
	        } else if (more >= 5) {
	            number = 'dni diety';
	        } else {
	            number = 'dni diety';
	        }
	        return more + ' ' + number;
	    },
	    processValidationError: function processValidationError(id, $el, msg) {
	
	        if (msg != null) {
	            if ($el.parent().find(".checkout_errors").length == 0) {
	                $el.parent().append("<div class='checkout_errors checkout_errors_" + id + "'>" + msg + "</div>");
	            } else {
	                $el.parent().find(".checkout_errors").html(msg);
	            }
	            $el.parent().addClass("woocommerce-invalid woocommerce-invalid-required-field").removeClass("woocommerce-validated");
	            return 1;
	        } else {
	            $el.parent().find(".checkout_errors").text('');
	            $el.parent().removeClass("woocommerce-invalid woocommerce-invalid-required-field");
	            return 0;
	        }
	    },
	    maskZipCode: function maskZipCode(id) {
	        var selector = document.getElementById(id);
	        var im = new Inputmask("99-999");
	        im.mask(selector);
	        $("#" + id).blur(function (ev) {
	            var that = this;
	            ev.stopPropagation();
	            setTimeout(function () {
	                if (Inputmask.isValid($(that).val(), { alias: '99-999' })) {
	                    $("#" + id + "_field").addClass("woocommerce-validated");
	                } else {
	                    $("#" + id + "_field").removeClass("woocommerce-validated").addClass("woocommerce-invalid").addClass("woocommerce-invalid-required-field");
	                }
	            }, 100);
	        });
	    },
	    is_phone: function is_phone(phone) {
	        return !(0 < phone.replace(/[\s\#0-9_\-\+\(\)]/g, '').trim().length);
	    },
	    is_postcode: function is_postcode(postcode /*country: poland*/) {
	        return !(postcode.replace(/[\s\-A-Za-z0-9]/g, '').trim().length > 0);
	    },
	
	    // NIP validation, taken from:
	    // http://blog.aleksander.kaweczynski.pl/walidacja-numerow-pesel-nip-regon-w-javascript-i-php/
	    validate_nip: function validate_nip(nip) {
	        var nip_bez_kresek = nip.replace(/-/g, "");
	        var reg = /^[0-9]{10}$/;
	        if (reg.test(nip_bez_kresek) == false) {
	            return false;
	        } else {
	            var dig = ("" + nip_bez_kresek).split("");
	            var kontrola = (6 * parseInt(dig[0]) + 5 * parseInt(dig[1]) + 7 * parseInt(dig[2]) + 2 * parseInt(dig[3]) + 3 * parseInt(dig[4]) + 4 * parseInt(dig[5]) + 5 * parseInt(dig[6]) + 6 * parseInt(dig[7]) + 7 * parseInt(dig[8])) % 11;
	            return parseInt(dig[9]) == kontrola;
	        }
	    },
	    elementInViewport: function elementInViewport(el, offsetTop) {
	        if (el instanceof jQuery) {
	            el = el[0];
	        }
	        var top = el.offsetTop;
	        var left = el.offsetLeft;
	        var width = el.offsetWidth;
	        var height = el.offsetHeight;
	
	        while (el.offsetParent) {
	            el = el.offsetParent;
	            top += el.offsetTop;
	            left += el.offsetLeft;
	        }
	        top -= offsetTop;
	        return top >= window.pageYOffset && left >= window.pageXOffset && top + height <= window.pageYOffset + window.innerHeight && left + width <= window.pageXOffset + window.innerWidth;
	    },
	    putSpinnerOn: function putSpinnerOn(el, isFixed) {
	        if (typeof el == 'string') {
	            el = $(el);
	        }
	        if (el === undefined) {
	            isFixed = true;
	            el = $("body");
	        }
	        clearTimeout(opacityTimeout);
	        clearTimeout(spinnerTimeout);
	        var $el = $(el);
	        var off = $el.offset();
	        var $spin = $(".cart_item_loader");
	        if (!$spin) {
	            return;
	        }
	        $spin.css({
	            display: "flex",
	            // display: "block",
	            left: off.left + "px",
	            top: off.top + "px",
	            width: $el.outerWidth() + "px",
	            height: $el.outerHeight() + "px",
	            opacity: 0,
	            position: isFixed ? 'fixed' : 'absolute'
	        });
	        $spin[0].render();
	        $spin.css({ opacity: 1 });
	        spinnerStartTime = Date.now();
	    },
	
	    /**
	     * If minTimeout is object as {min:INTEGER}, it checks how long spinner has been running. If less than INTEGER, it sets timeout
	     * @param minTimeout
	     * @param afterTimeout
	     */
	    disableSpinner: function disableSpinner(timeout, afterTimeout) {
	        if ((typeof timeout === "undefined" ? "undefined" : _typeof(timeout)) == "object") {
	            timeout = timeout.min;
	            var diff = Date.now() - spinnerStartTime;
	            if (diff < timeout) {
	                timeout = timeout - diff;
	            }
	        }
	        clearTimeout(opacityTimeout);
	        if (timeout) {
	            opacityTimeout = setTimeout(function () {
	                _doDisableSpinner();
	                if (afterTimeout) {
	                    afterTimeout();
	                }
	            }, timeout);
	        } else {
	            _doDisableSpinner();
	        }
	    }
	};
	exports.default = Utils;

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(385);
	
	__webpack_require__(384);
	
	__webpack_require__(386);
	
	__webpack_require__(396);
	
	__webpack_require__(393);
	
	__webpack_require__(395);
	
	__webpack_require__(398);
	
	__webpack_require__(394);
	
	__webpack_require__(397);
	
	__webpack_require__(341);
	
	__webpack_require__(380);
	
	__webpack_require__(376);
	
	var _utils = __webpack_require__(48);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	__webpack_require__(351);
	
	__webpack_require__(352);
	
	__webpack_require__(350);
	
	__webpack_require__(368);
	
	__webpack_require__(69);
	
	__webpack_require__(367);
	
	__webpack_require__(374);
	
	var _nav = __webpack_require__(372);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _ouibounce = __webpack_require__(354);
	
	var _ouibounce2 = _interopRequireDefault(_ouibounce);
	
	__webpack_require__(370);
	
	__webpack_require__(369);
	
	var _dialog = __webpack_require__(69);
	
	var _dialog2 = _interopRequireDefault(_dialog);
	
	var _cookies = __webpack_require__(349);
	
	var _cookies2 = _interopRequireDefault(_cookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './collapse';
	_nav2.default.init();
	// import 'modernizr';
	
	/** SCRIPTS **/
	
	
	/** VENDORS **/
	//require('photoswipe');
	
	
	/** CSS NATURACOLDPRESS **/
	/** CSS VENDORS **/
	
	
	$(document).on('ready', function () {
	    $('.show_more').click(function () {
	        var $el = $(this);
	        $el.closest('.diet__description').find('.bundle__description__header_more').slideToggle();
	        $el.toggleClass('open');
	        return false;
	    });
	
	    //add arrows to yellow section
	    if ($(window).width() > breakpoints.medium) {
	        $('.icon_text_wrap').after('<div class="icon_text_wrap icon-arrow-wrap"><div class="icon_text"><div class="icon_text__img_wrap"><img class="icon-arrow" src="/wordpress/wp-content/themes/ncp/assets/images/ikonki/arrow.png" alt="arrow"/></div></div></div>');
	    }
	
	    //cancel movie on home page
	    $('.home').find('#movie').css('display', 'none');
	
	    if ($(window).width() < breakpoints.medium) {
	        /** mobile **/
	        var $el = $('.przerywnik_extra .description');
	        $el.addClass('owl-carousel');
	        $el.owlCarousel({
	            center: true,
	            items: 1,
	            loop: true,
	            margin: 10,
	            nav: true,
	            navText: [' ', ' ']
	        });
	    } else {
	        var openNewsletter = function openNewsletter() {
	            console.log('Dialog fired!');
	            if (!newsletterEl) {
	                return;
	            }
	            new _dialog2.default(newsletterEl);
	            var form = newsletterEl.querySelector('form');
	
	            form.addEventListener('submit', function (e) {
	                e.preventDefault();
	                var email_address = form.querySelector('input[type=email]').value;
	                $(document).trigger({ type: 'signup', mail: [email_address] });
	
	                _utils2.default.putSpinnerOn($(".send"));
	                $.ajax({
	                    url: woocommerce_params.ajax_url,
	                    type: 'post',
	                    data: {
	                        action: 'newsletter_discount',
	                        email: email_address
	                    },
	                    success: function success(response) {
	
	                        var json = JSON.parse(response);
	
	                        if (window.dataLayer) {
	                            window.dataLayer.push({
	                                'event': 'form_submitted',
	                                'form_name': 'newsletter'
	                            });
	                        }
	
	                        if (json.status == "ok") {
	                            _utils2.default.disableSpinner();
	                            window.location.replace('https://naturacoldpress.us13.list-manage.com/subscribe/confirm?u=ed8fee390916d611989af5523&id=ba595d641a&e=c577cc7a45');
	                            setTimeout(function () {
	
	                                $(newsletterEl).remove();
	                            }, 6000);
	                        } else {
	                            _utils2.default.disableSpinner();
	                            window.location.replace('http://eepurl.com/bY7fZ5');
	                        }
	                    }
	                });
	            });
	        };
	
	        // desktop
	
	        var newsletterEl = document.getElementById('newsletter-modal');
	
	        var cookie_name = 'newslestter_active',
	            fire = _cookies2.default.read(cookie_name);
	        if (fire == null) {
	            _cookies2.default.create(cookie_name, '0', 110);
	        } else {
	            var times = parseInt(fire) + 1;
	            _cookies2.default.create(cookie_name, times < 4 ? times : 'never', 110);
	        }
	
	        if (fire != 'never') {
	            (0, _ouibounce2.default)(false, {
	                aggressive: true, callback: openNewsletter
	            });
	        }
	        $('.parallax-item').each(function (el) {
	            var img = new Image(),
	                parallax_img = $(this).find('img');
	            img.onload = function () {
	                parallax_img.attr('src', parallax_img.data('src')).delay(el * 50).fadeIn(300);
	            };
	            img.src = parallax_img.data('src');
	        }).promise().done(function () {
	            var scene = document.getElementById('parallax-scene');
	            if (scene) {
	                new Parallax(scene, {
	                    calibrateX: true,
	                    calibrateY: true,
	                    invertX: false,
	                    invertY: false,
	                    limitX: false,
	                    limitY: false,
	                    scalarX: 6,
	                    scalarY: 9,
	                    frictionX: 0.1,
	                    frictionY: 0.1,
	                    originX: 0.5,
	                    originY: 0.5
	                });
	            }
	        });
	    }
	
	    $(document).on('cf.submission', function (event, data) {
	        if (!data || !data.data || !data.data.status || !window.dataLayer) {
	            return;
	        }
	
	        if (data.data.status !== 'complete') {
	            return;
	        }
	
	        var formName = null;
	
	        switch (data.data.form_name) {
	            case 'Natura dla trenerów':
	                formName = 'natura-dla-trenerow';
	                break;
	            case 'Natura dla firma':
	                formName = 'natura-dla-firm';
	                break;
	        }
	
	        if (!formName) {
	            return;
	        }
	
	        window.dataLayer.push({
	            'event': 'form_submitted',
	            'form_name': formName
	        });
	    });
	});

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _desc, _value, _class;
	
	var _autobindDecorator = __webpack_require__(97);
	
	var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);
	
	var _Transition = __webpack_require__(355);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _navClick = __webpack_require__(139);
	
	var _navClick2 = _interopRequireDefault(_navClick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
		var desc = {};
		Object['ke' + 'ys'](descriptor).forEach(function (key) {
			desc[key] = descriptor[key];
		});
		desc.enumerable = !!desc.enumerable;
		desc.configurable = !!desc.configurable;
	
		if ('value' in desc || desc.initializer) {
			desc.writable = true;
		}
	
		desc = decorators.slice().reverse().reduce(function (desc, decorator) {
			return decorator(target, property, desc) || desc;
		}, desc);
	
		if (context && desc.initializer !== void 0) {
			desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
			desc.initializer = undefined;
		}
	
		if (desc.initializer === void 0) {
			Object['define' + 'Property'](target, property, desc);
			desc = null;
		}
	
		return desc;
	}
	
	var Nav = (_class = function () {
		function Nav() {
			_classCallCheck(this, Nav);
		}
	
		_createClass(Nav, [{
			key: "init",
			value: function init() {
				var _this = this;
	
				/* register click animation*/
				_navClick2.default.init('#boom');
	
				console.log('up');
	
				$('body').on('click', '.data-send-ue-cart, .quantity_change', function () {
	
					//console.log('clicked send');
					window.setTimeout(function () {
						$.ajax({
							method: 'GET',
							url: wp_ajaxurl,
							data: {
								action: 'send_cart_data_to_UE'
							}
						}).done(function (response) {
							console.log(response);
						});
					}, 2000);
				});
	
				var treshold = 280;
				this.lastScroll = $(window).scrollTop();
				this.isScrolling = false;
				this.isHidden = false;
				this.isOpenSlide = false;
				this.$nav = $("header.nav-wrap");
				var t = new _Transition2.default(this.$nav);
				var hasPopped = false;
				$(document).ready(function () {
					_this.$wrap = $(".nav-user-slide-wrap");
	
					if ($(window).width() <= breakpoints.large) {
	
						$('.menu-item-has-children').each(function () {
							var trigger = $(this).find('>a'),
							    sub = $(this).find('.sub-menu');
							trigger.click(function () {
								sub.toggleClass('open');
								return false;
							});
						});
					} else {
	
						$("header .open-login").click(_this.openSlide);
						$("header .open-register").click(_this.openSlide);
					}
	
					$('button.hamburger').click(function (e) {
						$('.nav_main').toggleClass('open');
					});
	
					if (false) {
						$(window).scroll(function () {
	
							var y = $(window).scrollTop();
							var goingDown = y > _this.lastScroll;
							var belowTreshold = y > treshold;
	
							if (belowTreshold) {
								hasPopped = false;
								t.pop('is-popped', 0);
								t.push('is-scrolling');
								if (goingDown) {
									t.pop('is-visible');
									_this.closeSlide();
								} else {
									t.push('is-visible');
								}
								t.pop('scrolling', 0);
							} else if (!hasPopped) {
								hasPopped = true;
								t.push('is-popped', 0);
								t.pop('is-visible').then(function () {
									_this.$nav[0].offsetHeight;
									t.pop('is-scrolling', 0);
								}, function () {
									_this.$nav[0].offsetHeight;
									t.pop('is-scrolling', 0);
								});
							}
							_this.lastScroll = y;
						}).scroll();
					}
	
					//$(".nav").on('click', Boom.boom);
					$(".logo_wrap").on('click', _navClick2.default.boom).on('click', function (ev) {
						if (document.body.classList.contains('home')) {
							$("html,body").animate({ scrollTop: 0 }, 500);
							ev.preventDefault();
						}
					});
					setTimeout(function () {
						window.addEventListener('resize', _this.handleResize);
						_this.handleResize();
					});
	
					var bg = document.querySelector('#login-backdrop');
					bg.addEventListener('click', _this.closeSlide);
				});
			}
		}, {
			key: "handleResize",
			value: function handleResize() {
				var $cur = $("header .menu-item.current-menu-item");
				if ($cur.length > 0) {
					$cur = $cur.children('a');
					var padding = 0; //parseInt($cur.css('padding-left'));
					var $i = $("header .indicator");
					setTimeout(function () {
						$i.css('transform', 'none');
					});
					$i.css({
						left: $cur.offset().left + padding + 'px',
						width: $cur.width() - padding * 2 + 'px',
						display: "block"
					});
				}
			}
		}, {
			key: "openSlide",
			value: function openSlide(ev) {
				ev.preventDefault();
				if (this.isOpenSlide) {
					//return;
				}
				this.isOpenSlide = true;
				var openLogin = ev.delegateTarget.classList.contains('open-login');
				var hasLogin = $(".nav-user-slide").hasClass('login-active');
				var hasActive = this.$wrap.hasClass('is-active');
				var bg = document.querySelector('#login-backdrop');
				if (hasActive && hasLogin == openLogin) {
					this.closeSlide();
					return;
				}
				document.body.classList.add('login-active');
				bg.offsetHeight;
				setTimeout(function () {
					bg.style.opacity = 1;
				}, 0);
				this.$wrap.addClass("is-active");
				if (openLogin) {
					$(".nav-user-slide").addClass('login-active');
				} else {
					$(".nav-user-slide").removeClass('login-active');
				}
				$("body").on('scroll', this._checkScroll);
			}
		}, {
			key: "closeSlide",
			value: function closeSlide() {
				if (!this.isOpenSlide) {
					return;
				}
				this.isOpenSlide = false;
				var bg = document.querySelector('#login-backdrop');
				this.$wrap.removeClass('is-active');
				bg.style.opacity = 0;
				bg.offsetHeight;
				setTimeout(function () {
					document.body.classList.remove('login-active');
				}, 200);
			}
		}, {
			key: "_checkScroll",
			value: function _checkScroll() {
				if (window.scrollY > this.$wrap.height()) {
					this.closeSlide();
				}
			}
		}]);
	
		return Nav;
	}(), (_applyDecoratedDescriptor(_class.prototype, "handleResize", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleResize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openSlide", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, "openSlide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeSlide", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, "closeSlide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_checkScroll", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, "_checkScroll"), _class.prototype)), _class);
	exports.default = new Nav();

/***/ }),

/***/ 374:
/***/ (function(module, exports) {

	'use strict';
	
	//============================================================
	//
	// The MIT License
	//
	// Copyright (C) 2014 Matthew Wagerfield - @wagerfield
	//
	// Permission is hereby granted, free of charge, to any
	// person obtaining a copy of this software and associated
	// documentation files (the "Software"), to deal in the
	// Software without restriction, including without limitation
	// the rights to use, copy, modify, merge, publish, distribute,
	// sublicense, and/or sell copies of the Software, and to
	// permit persons to whom the Software is furnished to do
	// so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice
	// shall be included in all copies or substantial portions
	// of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY
	// OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
	// LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
	// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO
	// EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE
	// FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN
	// AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	// OR OTHER DEALINGS IN THE SOFTWARE.
	//
	//============================================================
	
	/**
	 * Parallax.js
	 * @author Matthew Wagerfield - @wagerfield
	 * @description Creates a parallax effect between an array of layers,
	 *              driving the motion from the gyroscope output of a smartdevice.
	 *              If no gyroscope is available, the cursor position is used.
	 */
	;(function (window, document, undefined) {
	
	    // Strict Mode
	    'use strict';
	
	    // Constants
	
	    var NAME = 'Parallax';
	    var MAGIC_NUMBER = 30;
	    var DEFAULTS = {
	        relativeInput: false,
	        clipRelativeInput: false,
	        calibrationThreshold: 100,
	        calibrationDelay: 500,
	        supportDelay: 500,
	        calibrateX: false,
	        calibrateY: true,
	        invertX: true,
	        invertY: true,
	        limitX: false,
	        limitY: false,
	        scalarX: 10.0,
	        scalarY: 10.0,
	        frictionX: 0.1,
	        frictionY: 0.1,
	        originX: 0.5,
	        originY: 0.5,
	        pointerEvents: true,
	        precision: 1
	    };
	
	    function Parallax(element, options) {
	
	        // DOM Context
	        this.element = element;
	        this.layers = element.getElementsByClassName('layer');
	
	        // Data Extraction
	        var data = {
	            calibrateX: this.data(this.element, 'calibrate-x'),
	            calibrateY: this.data(this.element, 'calibrate-y'),
	            invertX: this.data(this.element, 'invert-x'),
	            invertY: this.data(this.element, 'invert-y'),
	            limitX: this.data(this.element, 'limit-x'),
	            limitY: this.data(this.element, 'limit-y'),
	            scalarX: this.data(this.element, 'scalar-x'),
	            scalarY: this.data(this.element, 'scalar-y'),
	            frictionX: this.data(this.element, 'friction-x'),
	            frictionY: this.data(this.element, 'friction-y'),
	            originX: this.data(this.element, 'origin-x'),
	            originY: this.data(this.element, 'origin-y'),
	            pointerEvents: this.data(this.element, 'pointer-events'),
	            precision: this.data(this.element, 'precision')
	        };
	
	        // Delete Null Data Values
	        for (var key in data) {
	            if (data[key] === null) delete data[key];
	        }
	
	        // Compose Settings Object
	        this.extend(this, DEFAULTS, options, data);
	
	        // States
	        this.calibrationTimer = null;
	        this.calibrationFlag = true;
	        this.enabled = false;
	        this.depthsX = [];
	        this.depthsY = [];
	        this.raf = null;
	
	        // Element Bounds
	        this.bounds = null;
	        this.ex = 0;
	        this.ey = 0;
	        this.ew = 0;
	        this.eh = 0;
	
	        // Element Center
	        this.ecx = 0;
	        this.ecy = 0;
	
	        // Element Range
	        this.erx = 0;
	        this.ery = 0;
	
	        // Calibration
	        this.cx = 0;
	        this.cy = 0;
	
	        // Input
	        this.ix = 0;
	        this.iy = 0;
	
	        // Motion
	        this.mx = 0;
	        this.my = 0;
	
	        // Velocity
	        this.vx = 0;
	        this.vy = 0;
	
	        // Callbacks
	        this.onMouseMove = this.onMouseMove.bind(this);
	        this.onDeviceOrientation = this.onDeviceOrientation.bind(this);
	        this.onOrientationTimer = this.onOrientationTimer.bind(this);
	        this.onCalibrationTimer = this.onCalibrationTimer.bind(this);
	        this.onAnimationFrame = this.onAnimationFrame.bind(this);
	        this.onWindowResize = this.onWindowResize.bind(this);
	
	        // Initialise
	        this.initialise();
	    }
	
	    Parallax.prototype.extend = function () {
	        if (arguments.length > 1) {
	            var master = arguments[0];
	            for (var i = 1, l = arguments.length; i < l; i++) {
	                var object = arguments[i];
	                for (var key in object) {
	                    master[key] = object[key];
	                }
	            }
	        }
	    };
	
	    Parallax.prototype.data = function (element, name) {
	        return this.deserialize(element.getAttribute('data-' + name));
	    };
	
	    Parallax.prototype.deserialize = function (value) {
	        if (value === 'true') {
	            return true;
	        } else if (value === 'false') {
	            return false;
	        } else if (value === 'null') {
	            return null;
	        } else if (!isNaN(parseFloat(value)) && isFinite(value)) {
	            return parseFloat(value);
	        } else {
	            return value;
	        }
	    };
	
	    Parallax.prototype.camelCase = function (value) {
	        return value.replace(/-+(.)?/g, function (match, character) {
	            return character ? character.toUpperCase() : '';
	        });
	    };
	
	    Parallax.prototype.transformSupport = function (value) {
	        var element = document.createElement('div');
	        var propertySupport = false;
	        var propertyValue = null;
	        var featureSupport = false;
	        var cssProperty = null;
	        var jsProperty = null;
	        for (var i = 0, l = this.vendors.length; i < l; i++) {
	            if (this.vendors[i] !== null) {
	                cssProperty = this.vendors[i][0] + 'transform';
	                jsProperty = this.vendors[i][1] + 'Transform';
	            } else {
	                cssProperty = 'transform';
	                jsProperty = 'transform';
	            }
	            if (element.style[jsProperty] !== undefined) {
	                propertySupport = true;
	                break;
	            }
	        }
	        switch (value) {
	            case '2D':
	                featureSupport = propertySupport;
	                break;
	            case '3D':
	                if (propertySupport) {
	                    var body = document.body || document.createElement('body');
	                    var documentElement = document.documentElement;
	                    var documentOverflow = documentElement.style.overflow;
	                    var isCreatedBody = false;
	                    if (!document.body) {
	                        isCreatedBody = true;
	                        documentElement.style.overflow = 'hidden';
	                        documentElement.appendChild(body);
	                        body.style.overflow = 'hidden';
	                        body.style.background = '';
	                    }
	                    body.appendChild(element);
	                    element.style[jsProperty] = 'translate3d(1px,1px,1px)';
	                    propertyValue = window.getComputedStyle(element).getPropertyValue(cssProperty);
	                    featureSupport = propertyValue !== undefined && propertyValue.length > 0 && propertyValue !== 'none';
	                    documentElement.style.overflow = documentOverflow;
	                    body.removeChild(element);
	                    if (isCreatedBody) {
	                        body.removeAttribute('style');
	                        body.parentNode.removeChild(body);
	                    }
	                }
	                break;
	        }
	        return featureSupport;
	    };
	
	    Parallax.prototype.ww = null;
	    Parallax.prototype.wh = null;
	    Parallax.prototype.wcx = null;
	    Parallax.prototype.wcy = null;
	    Parallax.prototype.wrx = null;
	    Parallax.prototype.wry = null;
	    Parallax.prototype.portrait = null;
	    Parallax.prototype.desktop = !navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry|BB10|mobi|tablet|opera mini|nexus 7)/i);
	    Parallax.prototype.vendors = [null, ['-webkit-', 'webkit'], ['-moz-', 'Moz'], ['-o-', 'O'], ['-ms-', 'ms']];
	    Parallax.prototype.motionSupport = !!window.DeviceMotionEvent;
	    Parallax.prototype.orientationSupport = !!window.DeviceOrientationEvent;
	    Parallax.prototype.orientationStatus = 0;
	    Parallax.prototype.motionStatus = 0;
	    Parallax.prototype.propertyCache = {};
	
	    Parallax.prototype.initialise = function () {
	
	        if (Parallax.prototype.transform2DSupport === undefined) {
	            Parallax.prototype.transform2DSupport = Parallax.prototype.transformSupport('2D');
	            Parallax.prototype.transform3DSupport = Parallax.prototype.transformSupport('3D');
	        }
	
	        // Configure Context Styles
	        if (this.transform3DSupport) this.accelerate(this.element);
	        var style = window.getComputedStyle(this.element);
	        if (style.getPropertyValue('position') === 'static') {
	            this.element.style.position = 'relative';
	        }
	
	        // Pointer events
	        if (!this.pointerEvents) {
	            this.element.style.pointerEvents = 'none';
	        }
	
	        // Setup
	        this.updateLayers();
	        this.updateDimensions();
	        this.enable();
	        this.queueCalibration(this.calibrationDelay);
	    };
	
	    Parallax.prototype.updateLayers = function () {
	
	        // Cache Layer Elements
	        this.layers = this.element.getElementsByClassName('layer');
	        this.depthsX = [];
	        this.depthsY = [];
	
	        // Configure Layer Styles
	        for (var i = 0, l = this.layers.length; i < l; i++) {
	            var layer = this.layers[i];
	            if (this.transform3DSupport) this.accelerate(layer);
	            layer.style.position = i ? 'absolute' : 'relative';
	            layer.style.display = 'block';
	            layer.style.left = 0;
	            layer.style.top = 0;
	
	            // Cache Layer Depth
	            //Graceful fallback on depth if depth-x or depth-y is absent
	            var depth = this.data(layer, 'depth') || 0;
	            this.depthsX.push(this.data(layer, 'depth-x') || depth);
	            this.depthsY.push(this.data(layer, 'depth-y') || depth);
	        }
	    };
	
	    Parallax.prototype.updateDimensions = function () {
	        this.ww = window.innerWidth;
	        this.wh = window.innerHeight;
	        this.wcx = this.ww * this.originX;
	        this.wcy = this.wh * this.originY;
	        this.wrx = Math.max(this.wcx, this.ww - this.wcx);
	        this.wry = Math.max(this.wcy, this.wh - this.wcy);
	    };
	
	    Parallax.prototype.updateBounds = function () {
	        this.bounds = this.element.getBoundingClientRect();
	        /** Fix by @partyka1 for Natura Cold Press case **/
	        this.bounds = {
	            left: 0,
	            width: window.innerWidth,
	            height: this.bounds.height,
	            top: this.bounds.top
	        };
	        this.ex = this.bounds.left;
	        this.ey = this.bounds.top;
	        this.ew = this.bounds.width;
	        this.eh = this.bounds.height;
	        this.ecx = this.ew * this.originX;
	        this.ecy = this.eh * this.originY;
	        this.erx = Math.max(this.ecx, this.ew - this.ecx);
	        this.ery = Math.max(this.ecy, this.eh - this.ecy);
	    };
	
	    Parallax.prototype.queueCalibration = function (delay) {
	        clearTimeout(this.calibrationTimer);
	        this.calibrationTimer = setTimeout(this.onCalibrationTimer, delay);
	    };
	
	    Parallax.prototype.enable = function () {
	        if (!this.enabled) {
	            this.enabled = true;
	            if (!this.desktop && this.orientationSupport) {
	                this.portrait = null;
	                window.addEventListener('deviceorientation', this.onDeviceOrientation);
	                setTimeout(this.onOrientationTimer, this.supportDelay);
	            } else if (!this.desktop && this.motionSupport) {
	                this.portrait = null;
	                window.addEventListener('devicemotion', this.onDeviceMotion);
	                setTimeout(this.onMotionTimer, this.supportDelay);
	            } else {
	                this.cx = 0;
	                this.cy = 0;
	                this.portrait = false;
	                window.addEventListener('mousemove', this.onMouseMove);
	            }
	            window.addEventListener('resize', this.onWindowResize);
	            this.raf = requestAnimationFrame(this.onAnimationFrame);
	        }
	    };
	
	    Parallax.prototype.disable = function () {
	        if (this.enabled) {
	            this.enabled = false;
	            if (this.orientationSupport) {
	                window.removeEventListener('deviceorientation', this.onDeviceOrientation);
	            } else if (this.motionSupport) {
	                window.removeEventListener('devicemotion', this.onDeviceMotion);
	            } else {
	                window.removeEventListener('mousemove', this.onMouseMove);
	            }
	            window.removeEventListener('resize', this.onWindowResize);
	            cancelAnimationFrame(this.raf);
	        }
	    };
	
	    Parallax.prototype.calibrate = function (x, y) {
	        this.calibrateX = x === undefined ? this.calibrateX : x;
	        this.calibrateY = y === undefined ? this.calibrateY : y;
	    };
	
	    Parallax.prototype.invert = function (x, y) {
	        this.invertX = x === undefined ? this.invertX : x;
	        this.invertY = y === undefined ? this.invertY : y;
	    };
	
	    Parallax.prototype.friction = function (x, y) {
	        this.frictionX = x === undefined ? this.frictionX : x;
	        this.frictionY = y === undefined ? this.frictionY : y;
	    };
	
	    Parallax.prototype.scalar = function (x, y) {
	        this.scalarX = x === undefined ? this.scalarX : x;
	        this.scalarY = y === undefined ? this.scalarY : y;
	    };
	
	    Parallax.prototype.limit = function (x, y) {
	        this.limitX = x === undefined ? this.limitX : x;
	        this.limitY = y === undefined ? this.limitY : y;
	    };
	
	    Parallax.prototype.origin = function (x, y) {
	        this.originX = x === undefined ? this.originX : x;
	        this.originY = y === undefined ? this.originY : y;
	    };
	
	    Parallax.prototype.clamp = function (value, min, max) {
	        value = Math.max(value, min);
	        value = Math.min(value, max);
	        return value;
	    };
	
	    Parallax.prototype.css = function (element, property, value) {
	        var jsProperty = this.propertyCache[property];
	        if (!jsProperty) {
	            for (var i = 0, l = this.vendors.length; i < l; i++) {
	                if (this.vendors[i] !== null) {
	                    jsProperty = this.camelCase(this.vendors[i][1] + '-' + property);
	                } else {
	                    jsProperty = property;
	                }
	                if (element.style[jsProperty] !== undefined) {
	                    this.propertyCache[property] = jsProperty;
	                    break;
	                }
	            }
	        }
	        element.style[jsProperty] = value;
	    };
	
	    Parallax.prototype.accelerate = function (element) {
	        this.css(element, 'transform', 'translate3d(0,0,0)');
	        this.css(element, 'transform-style', 'preserve-3d');
	        this.css(element, 'backface-visibility', 'hidden');
	    };
	
	    Parallax.prototype.setPosition = function (element, x, y) {
	        x = x.toFixed(this.precision) + 'px';
	        y = y.toFixed(this.precision) + 'px';
	        if (this.transform3DSupport) {
	            this.css(element, 'transform', 'translate3d(' + x + ',' + y + ',0)');
	        } else if (this.transform2DSupport) {
	            this.css(element, 'transform', 'translate(' + x + ',' + y + ')');
	        } else {
	            element.style.left = x;
	            element.style.top = y;
	        }
	    };
	
	    Parallax.prototype.onOrientationTimer = function () {
	        if (this.orientationSupport && this.orientationStatus === 0) {
	            this.disable();
	            this.orientationSupport = false;
	            this.enable();
	        }
	    };
	
	    Parallax.prototype.onMotionTimer = function () {
	        if (this.motionSupport && this.motionStatus === 0) {
	            this.disable();
	            this.motionSupport = false;
	            this.enable();
	        }
	    };
	
	    Parallax.prototype.onCalibrationTimer = function () {
	        this.calibrationFlag = true;
	    };
	
	    Parallax.prototype.onWindowResize = function () {
	        this.updateDimensions();
	    };
	
	    Parallax.prototype.onAnimationFrame = function () {
	        this.updateBounds();
	        var dx = this.ix - this.cx;
	        var dy = this.iy - this.cy;
	        if (Math.abs(dx) > this.calibrationThreshold || Math.abs(dy) > this.calibrationThreshold) {
	            this.queueCalibration(0);
	        }
	        if (this.portrait) {
	            this.mx = this.calibrateX ? dy : this.iy;
	            this.my = this.calibrateY ? dx : this.ix;
	        } else {
	            this.mx = this.calibrateX ? dx : this.ix;
	            this.my = this.calibrateY ? dy : this.iy;
	        }
	        this.mx *= this.ew * (this.scalarX / 100);
	        this.my *= this.eh * (this.scalarY / 100);
	        if (!isNaN(parseFloat(this.limitX))) {
	            this.mx = this.clamp(this.mx, -this.limitX, this.limitX);
	        }
	        if (!isNaN(parseFloat(this.limitY))) {
	            this.my = this.clamp(this.my, -this.limitY, this.limitY);
	        }
	        this.vx += (this.mx - this.vx) * this.frictionX;
	        this.vy += (this.my - this.vy) * this.frictionY;
	        for (var i = 0, l = this.layers.length; i < l; i++) {
	            var layer = this.layers[i];
	            var depthX = this.depthsX[i];
	            var depthY = this.depthsY[i];
	            var xOffset = this.vx * (depthX * (this.invertX ? -1 : 1));
	            var yOffset = this.vy * (depthY * (this.invertY ? -1 : 1));
	            this.setPosition(layer, xOffset, yOffset);
	        }
	        this.raf = requestAnimationFrame(this.onAnimationFrame);
	    };
	
	    Parallax.prototype.rotate = function (beta, gamma) {
	        // Extract Rotation
	        var x = (event.beta || 0) / MAGIC_NUMBER; //  -90 :: 90
	        var y = (event.gamma || 0) / MAGIC_NUMBER; // -180 :: 180
	
	        // Detect Orientation Change
	        var portrait = this.wh > this.ww;
	        if (this.portrait !== portrait) {
	            this.portrait = portrait;
	            this.calibrationFlag = true;
	        }
	
	        // Set Calibration
	        if (this.calibrationFlag) {
	            this.calibrationFlag = false;
	            this.cx = x;
	            this.cy = y;
	        }
	
	        // Set Input
	        this.ix = x;
	        this.iy = y;
	    };
	    Parallax.prototype.onDeviceOrientation = function (event) {
	        // Validate environment and event properties.
	        var beta = event.beta;
	        var gamma = event.gamma;
	        if (!this.desktop && beta !== null && gamma !== null) {
	            // Set orientation status.
	            this.orientationStatus = 1;
	            this.rotate(beta, gamma);
	        }
	    };
	
	    Parallax.prototype.onDeviceMotion = function (event) {
	        // Validate environment and event properties.
	        var beta = event.rotationRate.beta;
	        var gamma = event.rotationRate.gamma;
	        if (!this.desktop && beta !== null && gamma !== null) {
	            // Set motion status.
	            this.motionStatus = 1;
	            this.rotate(beta, gamma);
	        }
	    };
	
	    Parallax.prototype.onMouseMove = function (event) {
	        // Cache mouse coordinates.
	        var clientX = event.clientX;
	        var clientY = event.clientY;
	
	        // Calculate Mouse Input
	        if (!this.orientationSupport && this.relativeInput) {
	
	            // Clip mouse coordinates inside element bounds.
	            if (this.clipRelativeInput) {
	                clientX = Math.max(clientX, this.ex);
	                clientX = Math.min(clientX, this.ex + this.ew);
	                clientY = Math.max(clientY, this.ey);
	                clientY = Math.min(clientY, this.ey + this.eh);
	            }
	
	            // Calculate input relative to the element.
	            this.ix = (clientX - this.ex - this.ecx) / this.erx;
	            this.iy = (clientY - this.ey - this.ecy) / this.ery;
	        } else {
	
	            // Calculate input relative to the window.
	            this.ix = (clientX - this.wcx) / this.wrx;
	            this.iy = (clientY - this.wcy) / this.wry;
	        }
	    };
	
	    // Expose Parallax
	    window[NAME] = Parallax;
	})(window, document);
	
	/**
	 * Request Animation Frame Polyfill.
	 * @author Tino Zijdel
	 * @author Paul Irish
	 * @see https://gist.github.com/paulirish/1579671
	 */
	;(function () {
	
	    var lastTime = 0;
	    var vendors = ['ms', 'moz', 'webkit', 'o'];
	
	    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	    }
	
	    if (!window.requestAnimationFrame) {
	        window.requestAnimationFrame = function (callback, element) {
	            var currTime = new Date().getTime();
	            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	            var id = window.setTimeout(function () {
	                callback(currTime + timeToCall);
	            }, timeToCall);
	            lastTime = currTime + timeToCall;
	            return id;
	        };
	    }
	
	    if (!window.cancelAnimationFrame) {
	        window.cancelAnimationFrame = function (id) {
	            clearTimeout(id);
	        };
	    }
	})();

/***/ }),

/***/ 375:
/***/ (function(module, exports) {

	'use strict';
	
	$(document).ready(function () {
	    var facebookBtn = $('.wc-social-login');
	    var pageLink = window.location.href;
	    if (pageLink.indexOf('logowanie') >= 0 || pageLink.indexOf('rejestracja') >= 0) {
	        console.log('login lub rejestr');
	        $(facebookBtn).addClass('facebookRegisterBtn');
	    }
	});

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Owl Carousel v2.2.0
	 * Copyright 2013-2017 David Deutsch
	 * Licensed under  ()
	 */
	!function (a, b, c, d) {
	  function e(b, c) {
	    this.settings = null, this.options = a.extend({}, e.Defaults, c), this.$element = a(b), this._handlers = {}, this._plugins = {}, this._supress = {}, this._current = null, this._speed = null, this._coordinates = [], this._breakpoint = null, this._width = null, this._items = [], this._clones = [], this._mergers = [], this._widths = [], this._invalidated = {}, this._pipe = [], this._drag = { time: null, target: null, pointer: null, stage: { start: null, current: null }, direction: null }, this._states = { current: {}, tags: { initializing: ["busy"], animating: ["busy"], dragging: ["interacting"] } }, a.each(["onResize", "onThrottledResize"], a.proxy(function (b, c) {
	      this._handlers[c] = a.proxy(this[c], this);
	    }, this)), a.each(e.Plugins, a.proxy(function (a, b) {
	      this._plugins[a.charAt(0).toLowerCase() + a.slice(1)] = new b(this);
	    }, this)), a.each(e.Workers, a.proxy(function (b, c) {
	      this._pipe.push({ filter: c.filter, run: a.proxy(c.run, this) });
	    }, this)), this.setup(), this.initialize();
	  }e.Defaults = { items: 3, loop: !1, center: !1, rewind: !1, mouseDrag: !0, touchDrag: !0, pullDrag: !0, freeDrag: !1, margin: 0, stagePadding: 0, merge: !1, mergeFit: !0, autoWidth: !1, startPosition: 0, rtl: !1, smartSpeed: 250, fluidSpeed: !1, dragEndSpeed: !1, responsive: {}, responsiveRefreshRate: 200, responsiveBaseElement: b, fallbackEasing: "swing", info: !1, nestedItemSelector: !1, itemElement: "div", stageElement: "div", refreshClass: "owl-refresh", loadedClass: "owl-loaded", loadingClass: "owl-loading", rtlClass: "owl-rtl", responsiveClass: "owl-responsive", dragClass: "owl-drag", itemClass: "owl-item", stageClass: "owl-stage", stageOuterClass: "owl-stage-outer", grabClass: "owl-grab" }, e.Width = { Default: "default", Inner: "inner", Outer: "outer" }, e.Type = { Event: "event", State: "state" }, e.Plugins = {}, e.Workers = [{ filter: ["width", "settings"], run: function run() {
	      this._width = this.$element.width();
	    } }, { filter: ["width", "items", "settings"], run: function run(a) {
	      a.current = this._items && this._items[this.relative(this._current)];
	    } }, { filter: ["items", "settings"], run: function run() {
	      this.$stage.children(".cloned").remove();
	    } }, { filter: ["width", "items", "settings"], run: function run(a) {
	      var b = this.settings.margin || "",
	          c = !this.settings.autoWidth,
	          d = this.settings.rtl,
	          e = { width: "auto", "margin-left": d ? b : "", "margin-right": d ? "" : b };!c && this.$stage.children().css(e), a.css = e;
	    } }, { filter: ["width", "items", "settings"], run: function run(a) {
	      var b = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
	          c = null,
	          d = this._items.length,
	          e = !this.settings.autoWidth,
	          f = [];for (a.items = { merge: !1, width: b }; d--;) {
	        c = this._mergers[d], c = this.settings.mergeFit && Math.min(c, this.settings.items) || c, a.items.merge = c > 1 || a.items.merge, f[d] = e ? b * c : this._items[d].width();
	      }this._widths = f;
	    } }, { filter: ["items", "settings"], run: function run() {
	      var b = [],
	          c = this._items,
	          d = this.settings,
	          e = Math.max(2 * d.items, 4),
	          f = 2 * Math.ceil(c.length / 2),
	          g = d.loop && c.length ? d.rewind ? e : Math.max(e, f) : 0,
	          h = "",
	          i = "";for (g /= 2; g--;) {
	        b.push(this.normalize(b.length / 2, !0)), h += c[b[b.length - 1]][0].outerHTML, b.push(this.normalize(c.length - 1 - (b.length - 1) / 2, !0)), i = c[b[b.length - 1]][0].outerHTML + i;
	      }this._clones = b, a(h).addClass("cloned").appendTo(this.$stage), a(i).addClass("cloned").prependTo(this.$stage);
	    } }, { filter: ["width", "items", "settings"], run: function run() {
	      for (var a = this.settings.rtl ? 1 : -1, b = this._clones.length + this._items.length, c = -1, d = 0, e = 0, f = []; ++c < b;) {
	        d = f[c - 1] || 0, e = this._widths[this.relative(c)] + this.settings.margin, f.push(d + e * a);
	      }this._coordinates = f;
	    } }, { filter: ["width", "items", "settings"], run: function run() {
	      var a = this.settings.stagePadding,
	          b = this._coordinates,
	          c = { width: Math.ceil(Math.abs(b[b.length - 1])) + 2 * a, "padding-left": a || "", "padding-right": a || "" };this.$stage.css(c);
	    } }, { filter: ["width", "items", "settings"], run: function run(a) {
	      var b = this._coordinates.length,
	          c = !this.settings.autoWidth,
	          d = this.$stage.children();if (c && a.items.merge) for (; b--;) {
	        a.css.width = this._widths[this.relative(b)], d.eq(b).css(a.css);
	      } else c && (a.css.width = a.items.width, d.css(a.css));
	    } }, { filter: ["items"], run: function run() {
	      this._coordinates.length < 1 && this.$stage.removeAttr("style");
	    } }, { filter: ["width", "items", "settings"], run: function run(a) {
	      a.current = a.current ? this.$stage.children().index(a.current) : 0, a.current = Math.max(this.minimum(), Math.min(this.maximum(), a.current)), this.reset(a.current);
	    } }, { filter: ["position"], run: function run() {
	      this.animate(this.coordinates(this._current));
	    } }, { filter: ["width", "position", "items", "settings"], run: function run() {
	      var a,
	          b,
	          c,
	          d,
	          e = this.settings.rtl ? 1 : -1,
	          f = 2 * this.settings.stagePadding,
	          g = this.coordinates(this.current()) + f,
	          h = g + this.width() * e,
	          i = [];for (c = 0, d = this._coordinates.length; c < d; c++) {
	        a = this._coordinates[c - 1] || 0, b = Math.abs(this._coordinates[c]) + f * e, (this.op(a, "<=", g) && this.op(a, ">", h) || this.op(b, "<", g) && this.op(b, ">", h)) && i.push(c);
	      }this.$stage.children(".active").removeClass("active"), this.$stage.children(":eq(" + i.join("), :eq(") + ")").addClass("active"), this.settings.center && (this.$stage.children(".center").removeClass("center"), this.$stage.children().eq(this.current()).addClass("center"));
	    } }], e.prototype.initialize = function () {
	    if (this.enter("initializing"), this.trigger("initialize"), this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl), this.settings.autoWidth && !this.is("pre-loading")) {
	      var b, c, e;b = this.$element.find("img"), c = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : d, e = this.$element.children(c).width(), b.length && e <= 0 && this.preloadAutoWidthImages(b);
	    }this.$element.addClass(this.options.loadingClass), this.$stage = a("<" + this.settings.stageElement + ' class="' + this.settings.stageClass + '"/>').wrap('<div class="' + this.settings.stageOuterClass + '"/>'), this.$element.append(this.$stage.parent()), this.replace(this.$element.children().not(this.$stage.parent())), this.$element.is(":visible") ? this.refresh() : this.invalidate("width"), this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass), this.registerEventHandlers(), this.leave("initializing"), this.trigger("initialized");
	  }, e.prototype.setup = function () {
	    var b = this.viewport(),
	        c = this.options.responsive,
	        d = -1,
	        e = null;c ? (a.each(c, function (a) {
	      a <= b && a > d && (d = Number(a));
	    }), e = a.extend({}, this.options, c[d]), "function" == typeof e.stagePadding && (e.stagePadding = e.stagePadding()), delete e.responsive, e.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + d))) : e = a.extend({}, this.options), this.trigger("change", { property: { name: "settings", value: e } }), this._breakpoint = d, this.settings = e, this.invalidate("settings"), this.trigger("changed", { property: { name: "settings", value: this.settings } });
	  }, e.prototype.optionsLogic = function () {
	    this.settings.autoWidth && (this.settings.stagePadding = !1, this.settings.merge = !1);
	  }, e.prototype.prepare = function (b) {
	    var c = this.trigger("prepare", { content: b });return c.data || (c.data = a("<" + this.settings.itemElement + "/>").addClass(this.options.itemClass).append(b)), this.trigger("prepared", { content: c.data }), c.data;
	  }, e.prototype.update = function () {
	    for (var b = 0, c = this._pipe.length, d = a.proxy(function (a) {
	      return this[a];
	    }, this._invalidated), e = {}; b < c;) {
	      (this._invalidated.all || a.grep(this._pipe[b].filter, d).length > 0) && this._pipe[b].run(e), b++;
	    }this._invalidated = {}, !this.is("valid") && this.enter("valid");
	  }, e.prototype.width = function (a) {
	    switch (a = a || e.Width.Default) {case e.Width.Inner:case e.Width.Outer:
	        return this._width;default:
	        return this._width - 2 * this.settings.stagePadding + this.settings.margin;}
	  }, e.prototype.refresh = function () {
	    this.enter("refreshing"), this.trigger("refresh"), this.setup(), this.optionsLogic(), this.$element.addClass(this.options.refreshClass), this.update(), this.$element.removeClass(this.options.refreshClass), this.leave("refreshing"), this.trigger("refreshed");
	  }, e.prototype.onThrottledResize = function () {
	    b.clearTimeout(this.resizeTimer), this.resizeTimer = b.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);
	  }, e.prototype.onResize = function () {
	    return !!this._items.length && this._width !== this.$element.width() && !!this.$element.is(":visible") && (this.enter("resizing"), this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), !1) : (this.invalidate("width"), this.refresh(), this.leave("resizing"), void this.trigger("resized")));
	  }, e.prototype.registerEventHandlers = function () {
	    a.support.transition && this.$stage.on(a.support.transition.end + ".owl.core", a.proxy(this.onTransitionEnd, this)), this.settings.responsive !== !1 && this.on(b, "resize", this._handlers.onThrottledResize), this.settings.mouseDrag && (this.$element.addClass(this.options.dragClass), this.$stage.on("mousedown.owl.core", a.proxy(this.onDragStart, this)), this.$stage.on("dragstart.owl.core selectstart.owl.core", function () {
	      return !1;
	    })), this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", a.proxy(this.onDragStart, this)), this.$stage.on("touchcancel.owl.core", a.proxy(this.onDragEnd, this)));
	  }, e.prototype.onDragStart = function (b) {
	    var d = null;3 !== b.which && (a.support.transform ? (d = this.$stage.css("transform").replace(/.*\(|\)| /g, "").split(","), d = { x: d[16 === d.length ? 12 : 4], y: d[16 === d.length ? 13 : 5] }) : (d = this.$stage.position(), d = { x: this.settings.rtl ? d.left + this.$stage.width() - this.width() + this.settings.margin : d.left, y: d.top }), this.is("animating") && (a.support.transform ? this.animate(d.x) : this.$stage.stop(), this.invalidate("position")), this.$element.toggleClass(this.options.grabClass, "mousedown" === b.type), this.speed(0), this._drag.time = new Date().getTime(), this._drag.target = a(b.target), this._drag.stage.start = d, this._drag.stage.current = d, this._drag.pointer = this.pointer(b), a(c).on("mouseup.owl.core touchend.owl.core", a.proxy(this.onDragEnd, this)), a(c).one("mousemove.owl.core touchmove.owl.core", a.proxy(function (b) {
	      var d = this.difference(this._drag.pointer, this.pointer(b));a(c).on("mousemove.owl.core touchmove.owl.core", a.proxy(this.onDragMove, this)), Math.abs(d.x) < Math.abs(d.y) && this.is("valid") || (b.preventDefault(), this.enter("dragging"), this.trigger("drag"));
	    }, this)));
	  }, e.prototype.onDragMove = function (a) {
	    var b = null,
	        c = null,
	        d = null,
	        e = this.difference(this._drag.pointer, this.pointer(a)),
	        f = this.difference(this._drag.stage.start, e);this.is("dragging") && (a.preventDefault(), this.settings.loop ? (b = this.coordinates(this.minimum()), c = this.coordinates(this.maximum() + 1) - b, f.x = ((f.x - b) % c + c) % c + b) : (b = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()), c = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()), d = this.settings.pullDrag ? -1 * e.x / 5 : 0, f.x = Math.max(Math.min(f.x, b + d), c + d)), this._drag.stage.current = f, this.animate(f.x));
	  }, e.prototype.onDragEnd = function (b) {
	    var d = this.difference(this._drag.pointer, this.pointer(b)),
	        e = this._drag.stage.current,
	        f = d.x > 0 ^ this.settings.rtl ? "left" : "right";a(c).off(".owl.core"), this.$element.removeClass(this.options.grabClass), (0 !== d.x && this.is("dragging") || !this.is("valid")) && (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), this.current(this.closest(e.x, 0 !== d.x ? f : this._drag.direction)), this.invalidate("position"), this.update(), this._drag.direction = f, (Math.abs(d.x) > 3 || new Date().getTime() - this._drag.time > 300) && this._drag.target.one("click.owl.core", function () {
	      return !1;
	    })), this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"));
	  }, e.prototype.closest = function (b, c) {
	    var d = -1,
	        e = 30,
	        f = this.width(),
	        g = this.coordinates();return this.settings.freeDrag || a.each(g, a.proxy(function (a, h) {
	      return "left" === c && b > h - e && b < h + e ? d = a : "right" === c && b > h - f - e && b < h - f + e ? d = a + 1 : this.op(b, "<", h) && this.op(b, ">", g[a + 1] || h - f) && (d = "left" === c ? a + 1 : a), d === -1;
	    }, this)), this.settings.loop || (this.op(b, ">", g[this.minimum()]) ? d = b = this.minimum() : this.op(b, "<", g[this.maximum()]) && (d = b = this.maximum())), d;
	  }, e.prototype.animate = function (b) {
	    var c = this.speed() > 0;this.is("animating") && this.onTransitionEnd(), c && (this.enter("animating"), this.trigger("translate")), a.support.transform3d && a.support.transition ? this.$stage.css({ transform: "translate3d(" + b + "px,0px,0px)", transition: this.speed() / 1e3 + "s" }) : c ? this.$stage.animate({ left: b + "px" }, this.speed(), this.settings.fallbackEasing, a.proxy(this.onTransitionEnd, this)) : this.$stage.css({ left: b + "px" });
	  }, e.prototype.is = function (a) {
	    return this._states.current[a] && this._states.current[a] > 0;
	  }, e.prototype.current = function (a) {
	    if (a === d) return this._current;if (0 === this._items.length) return d;if (a = this.normalize(a), this._current !== a) {
	      var b = this.trigger("change", { property: { name: "position", value: a } });b.data !== d && (a = this.normalize(b.data)), this._current = a, this.invalidate("position"), this.trigger("changed", { property: { name: "position", value: this._current } });
	    }return this._current;
	  }, e.prototype.invalidate = function (b) {
	    return "string" === a.type(b) && (this._invalidated[b] = !0, this.is("valid") && this.leave("valid")), a.map(this._invalidated, function (a, b) {
	      return b;
	    });
	  }, e.prototype.reset = function (a) {
	    a = this.normalize(a), a !== d && (this._speed = 0, this._current = a, this.suppress(["translate", "translated"]), this.animate(this.coordinates(a)), this.release(["translate", "translated"]));
	  }, e.prototype.normalize = function (a, b) {
	    var c = this._items.length,
	        e = b ? 0 : this._clones.length;return !this.isNumeric(a) || c < 1 ? a = d : (a < 0 || a >= c + e) && (a = ((a - e / 2) % c + c) % c + e / 2), a;
	  }, e.prototype.relative = function (a) {
	    return a -= this._clones.length / 2, this.normalize(a, !0);
	  }, e.prototype.maximum = function (a) {
	    var b,
	        c,
	        d,
	        e = this.settings,
	        f = this._coordinates.length;if (e.loop) f = this._clones.length / 2 + this._items.length - 1;else if (e.autoWidth || e.merge) {
	      for (b = this._items.length, c = this._items[--b].width(), d = this.$element.width(); b-- && (c += this._items[b].width() + this.settings.margin, !(c > d));) {}f = b + 1;
	    } else f = e.center ? this._items.length - 1 : this._items.length - e.items;return a && (f -= this._clones.length / 2), Math.max(f, 0);
	  }, e.prototype.minimum = function (a) {
	    return a ? 0 : this._clones.length / 2;
	  }, e.prototype.items = function (a) {
	    return a === d ? this._items.slice() : (a = this.normalize(a, !0), this._items[a]);
	  }, e.prototype.mergers = function (a) {
	    return a === d ? this._mergers.slice() : (a = this.normalize(a, !0), this._mergers[a]);
	  }, e.prototype.clones = function (b) {
	    var c = this._clones.length / 2,
	        e = c + this._items.length,
	        f = function f(a) {
	      return a % 2 === 0 ? e + a / 2 : c - (a + 1) / 2;
	    };return b === d ? a.map(this._clones, function (a, b) {
	      return f(b);
	    }) : a.map(this._clones, function (a, c) {
	      return a === b ? f(c) : null;
	    });
	  }, e.prototype.speed = function (a) {
	    return a !== d && (this._speed = a), this._speed;
	  }, e.prototype.coordinates = function (b) {
	    var c,
	        e = 1,
	        f = b - 1;return b === d ? a.map(this._coordinates, a.proxy(function (a, b) {
	      return this.coordinates(b);
	    }, this)) : (this.settings.center ? (this.settings.rtl && (e = -1, f = b + 1), c = this._coordinates[b], c += (this.width() - c + (this._coordinates[f] || 0)) / 2 * e) : c = this._coordinates[f] || 0, c = Math.ceil(c));
	  }, e.prototype.duration = function (a, b, c) {
	    return 0 === c ? 0 : Math.min(Math.max(Math.abs(b - a), 1), 6) * Math.abs(c || this.settings.smartSpeed);
	  }, e.prototype.to = function (a, b) {
	    var c = this.current(),
	        d = null,
	        e = a - this.relative(c),
	        f = (e > 0) - (e < 0),
	        g = this._items.length,
	        h = this.minimum(),
	        i = this.maximum();this.settings.loop ? (!this.settings.rewind && Math.abs(e) > g / 2 && (e += f * -1 * g), a = c + e, d = ((a - h) % g + g) % g + h, d !== a && d - e <= i && d - e > 0 && (c = d - e, a = d, this.reset(c))) : this.settings.rewind ? (i += 1, a = (a % i + i) % i) : a = Math.max(h, Math.min(i, a)), this.speed(this.duration(c, a, b)), this.current(a), this.$element.is(":visible") && this.update();
	  }, e.prototype.next = function (a) {
	    a = a || !1, this.to(this.relative(this.current()) + 1, a);
	  }, e.prototype.prev = function (a) {
	    a = a || !1, this.to(this.relative(this.current()) - 1, a);
	  }, e.prototype.onTransitionEnd = function (a) {
	    return (a === d || (a.stopPropagation(), (a.target || a.srcElement || a.originalTarget) === this.$stage.get(0))) && (this.leave("animating"), void this.trigger("translated"));
	  }, e.prototype.viewport = function () {
	    var d;if (this.options.responsiveBaseElement !== b) d = a(this.options.responsiveBaseElement).width();else if (b.innerWidth) d = b.innerWidth;else {
	      if (!c.documentElement || !c.documentElement.clientWidth) throw "Can not detect viewport width.";d = c.documentElement.clientWidth;
	    }return d;
	  }, e.prototype.replace = function (b) {
	    this.$stage.empty(), this._items = [], b && (b = b instanceof jQuery ? b : a(b)), this.settings.nestedItemSelector && (b = b.find("." + this.settings.nestedItemSelector)), b.filter(function () {
	      return 1 === this.nodeType;
	    }).each(a.proxy(function (a, b) {
	      b = this.prepare(b), this.$stage.append(b), this._items.push(b), this._mergers.push(1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1);
	    }, this)), this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0), this.invalidate("items");
	  }, e.prototype.add = function (b, c) {
	    var e = this.relative(this._current);c = c === d ? this._items.length : this.normalize(c, !0), b = b instanceof jQuery ? b : a(b), this.trigger("add", { content: b, position: c }), b = this.prepare(b), 0 === this._items.length || c === this._items.length ? (0 === this._items.length && this.$stage.append(b), 0 !== this._items.length && this._items[c - 1].after(b), this._items.push(b), this._mergers.push(1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)) : (this._items[c].before(b), this._items.splice(c, 0, b), this._mergers.splice(c, 0, 1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)), this._items[e] && this.reset(this._items[e].index()), this.invalidate("items"), this.trigger("added", { content: b, position: c });
	  }, e.prototype.remove = function (a) {
	    a = this.normalize(a, !0), a !== d && (this.trigger("remove", { content: this._items[a], position: a }), this._items[a].remove(), this._items.splice(a, 1), this._mergers.splice(a, 1), this.invalidate("items"), this.trigger("removed", { content: null, position: a }));
	  }, e.prototype.preloadAutoWidthImages = function (b) {
	    b.each(a.proxy(function (b, c) {
	      this.enter("pre-loading"), c = a(c), a(new Image()).one("load", a.proxy(function (a) {
	        c.attr("src", a.target.src), c.css("opacity", 1), this.leave("pre-loading"), !this.is("pre-loading") && !this.is("initializing") && this.refresh();
	      }, this)).attr("src", c.attr("src") || c.attr("data-src") || c.attr("data-src-retina"));
	    }, this));
	  }, e.prototype.destroy = function () {
	    this.$element.off(".owl.core"), this.$stage.off(".owl.core"), a(c).off(".owl.core"), this.settings.responsive !== !1 && (b.clearTimeout(this.resizeTimer), this.off(b, "resize", this._handlers.onThrottledResize));for (var d in this._plugins) {
	      this._plugins[d].destroy();
	    }this.$stage.children(".cloned").remove(), this.$stage.unwrap(), this.$stage.children().contents().unwrap(), this.$stage.children().unwrap(), this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), "")).removeData("owl.carousel");
	  }, e.prototype.op = function (a, b, c) {
	    var d = this.settings.rtl;switch (b) {case "<":
	        return d ? a > c : a < c;case ">":
	        return d ? a < c : a > c;case ">=":
	        return d ? a <= c : a >= c;case "<=":
	        return d ? a >= c : a <= c;}
	  }, e.prototype.on = function (a, b, c, d) {
	    a.addEventListener ? a.addEventListener(b, c, d) : a.attachEvent && a.attachEvent("on" + b, c);
	  }, e.prototype.off = function (a, b, c, d) {
	    a.removeEventListener ? a.removeEventListener(b, c, d) : a.detachEvent && a.detachEvent("on" + b, c);
	  }, e.prototype.trigger = function (b, c, d, f, g) {
	    var h = { item: { count: this._items.length, index: this.current() } },
	        i = a.camelCase(a.grep(["on", b, d], function (a) {
	      return a;
	    }).join("-").toLowerCase()),
	        j = a.Event([b, "owl", d || "carousel"].join(".").toLowerCase(), a.extend({ relatedTarget: this }, h, c));return this._supress[b] || (a.each(this._plugins, function (a, b) {
	      b.onTrigger && b.onTrigger(j);
	    }), this.register({ type: e.Type.Event, name: b }), this.$element.trigger(j), this.settings && "function" == typeof this.settings[i] && this.settings[i].call(this, j)), j;
	  }, e.prototype.enter = function (b) {
	    a.each([b].concat(this._states.tags[b] || []), a.proxy(function (a, b) {
	      this._states.current[b] === d && (this._states.current[b] = 0), this._states.current[b]++;
	    }, this));
	  }, e.prototype.leave = function (b) {
	    a.each([b].concat(this._states.tags[b] || []), a.proxy(function (a, b) {
	      this._states.current[b]--;
	    }, this));
	  }, e.prototype.register = function (b) {
	    if (b.type === e.Type.Event) {
	      if (a.event.special[b.name] || (a.event.special[b.name] = {}), !a.event.special[b.name].owl) {
	        var c = a.event.special[b.name]._default;a.event.special[b.name]._default = function (a) {
	          return !c || !c.apply || a.namespace && a.namespace.indexOf("owl") !== -1 ? a.namespace && a.namespace.indexOf("owl") > -1 : c.apply(this, arguments);
	        }, a.event.special[b.name].owl = !0;
	      }
	    } else b.type === e.Type.State && (this._states.tags[b.name] ? this._states.tags[b.name] = this._states.tags[b.name].concat(b.tags) : this._states.tags[b.name] = b.tags, this._states.tags[b.name] = a.grep(this._states.tags[b.name], a.proxy(function (c, d) {
	      return a.inArray(c, this._states.tags[b.name]) === d;
	    }, this)));
	  }, e.prototype.suppress = function (b) {
	    a.each(b, a.proxy(function (a, b) {
	      this._supress[b] = !0;
	    }, this));
	  }, e.prototype.release = function (b) {
	    a.each(b, a.proxy(function (a, b) {
	      delete this._supress[b];
	    }, this));
	  }, e.prototype.pointer = function (a) {
	    var c = { x: null, y: null };return a = a.originalEvent || a || b.event, a = a.touches && a.touches.length ? a.touches[0] : a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : a, a.pageX ? (c.x = a.pageX, c.y = a.pageY) : (c.x = a.clientX, c.y = a.clientY), c;
	  }, e.prototype.isNumeric = function (a) {
	    return !isNaN(parseFloat(a));
	  }, e.prototype.difference = function (a, b) {
	    return { x: a.x - b.x, y: a.y - b.y };
	  }, a.fn.owlCarousel = function (b) {
	    var c = Array.prototype.slice.call(arguments, 1);return this.each(function () {
	      var d = a(this),
	          f = d.data("owl.carousel");f || (f = new e(this, "object" == (typeof b === "undefined" ? "undefined" : _typeof(b)) && b), d.data("owl.carousel", f), a.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function (b, c) {
	        f.register({ type: e.Type.Event, name: c }), f.$element.on(c + ".owl.carousel.core", a.proxy(function (a) {
	          a.namespace && a.relatedTarget !== this && (this.suppress([c]), f[c].apply(this, [].slice.call(arguments, 1)), this.release([c]));
	        }, f));
	      })), "string" == typeof b && "_" !== b.charAt(0) && f[b].apply(f, c);
	    });
	  }, a.fn.owlCarousel.Constructor = e;
	}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
	  var e = function e(b) {
	    this._core = b, this._interval = null, this._visible = null, this._handlers = { "initialized.owl.carousel": a.proxy(function (a) {
	        a.namespace && this._core.settings.autoRefresh && this.watch();
	      }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers);
	  };e.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }, e.prototype.watch = function () {
	    this._interval || (this._visible = this._core.$element.is(":visible"), this._interval = b.setInterval(a.proxy(this.refresh, this), this._core.settings.autoRefreshInterval));
	  }, e.prototype.refresh = function () {
	    this._core.$element.is(":visible") !== this._visible && (this._visible = !this._visible, this._core.$element.toggleClass("owl-hidden", !this._visible), this._visible && this._core.invalidate("width") && this._core.refresh());
	  }, e.prototype.destroy = function () {
	    var a, c;b.clearInterval(this._interval);for (a in this._handlers) {
	      this._core.$element.off(a, this._handlers[a]);
	    }for (c in Object.getOwnPropertyNames(this)) {
	      "function" != typeof this[c] && (this[c] = null);
	    }
	  }, a.fn.owlCarousel.Constructor.Plugins.AutoRefresh = e;
	}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
	  var e = function e(b) {
	    this._core = b, this._loaded = [], this._handlers = { "initialized.owl.carousel change.owl.carousel resized.owl.carousel": a.proxy(function (b) {
	        if (b.namespace && this._core.settings && this._core.settings.lazyLoad && (b.property && "position" == b.property.name || "initialized" == b.type)) for (var c = this._core.settings, e = c.center && Math.ceil(c.items / 2) || c.items, f = c.center && e * -1 || 0, g = (b.property && b.property.value !== d ? b.property.value : this._core.current()) + f, h = this._core.clones().length, i = a.proxy(function (a, b) {
	          this.load(b);
	        }, this); f++ < e;) {
	          this.load(h / 2 + this._core.relative(g)), h && a.each(this._core.clones(this._core.relative(g)), i), g++;
	        }
	      }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers);
	  };e.Defaults = { lazyLoad: !1 }, e.prototype.load = function (c) {
	    var d = this._core.$stage.children().eq(c),
	        e = d && d.find(".owl-lazy");!e || a.inArray(d.get(0), this._loaded) > -1 || (e.each(a.proxy(function (c, d) {
	      var e,
	          f = a(d),
	          g = b.devicePixelRatio > 1 && f.attr("data-src-retina") || f.attr("data-src");this._core.trigger("load", { element: f, url: g }, "lazy"), f.is("img") ? f.one("load.owl.lazy", a.proxy(function () {
	        f.css("opacity", 1), this._core.trigger("loaded", { element: f, url: g }, "lazy");
	      }, this)).attr("src", g) : (e = new Image(), e.onload = a.proxy(function () {
	        f.css({ "background-image": "url(" + g + ")", opacity: "1" }), this._core.trigger("loaded", { element: f, url: g }, "lazy");
	      }, this), e.src = g);
	    }, this)), this._loaded.push(d.get(0)));
	  }, e.prototype.destroy = function () {
	    var a, b;for (a in this.handlers) {
	      this._core.$element.off(a, this.handlers[a]);
	    }for (b in Object.getOwnPropertyNames(this)) {
	      "function" != typeof this[b] && (this[b] = null);
	    }
	  }, a.fn.owlCarousel.Constructor.Plugins.Lazy = e;
	}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
	  var e = function e(b) {
	    this._core = b, this._handlers = { "initialized.owl.carousel refreshed.owl.carousel": a.proxy(function (a) {
	        a.namespace && this._core.settings.autoHeight && this.update();
	      }, this), "changed.owl.carousel": a.proxy(function (a) {
	        a.namespace && this._core.settings.autoHeight && "position" == a.property.name && this.update();
	      }, this), "loaded.owl.lazy": a.proxy(function (a) {
	        a.namespace && this._core.settings.autoHeight && a.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update();
	      }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers);
	  };e.Defaults = { autoHeight: !1, autoHeightClass: "owl-height" }, e.prototype.update = function () {
	    var b = this._core._current,
	        c = b + this._core.settings.items,
	        d = this._core.$stage.children().toArray().slice(b, c),
	        e = [],
	        f = 0;a.each(d, function (b, c) {
	      e.push(a(c).height());
	    }), f = Math.max.apply(null, e), this._core.$stage.parent().height(f).addClass(this._core.settings.autoHeightClass);
	  }, e.prototype.destroy = function () {
	    var a, b;for (a in this._handlers) {
	      this._core.$element.off(a, this._handlers[a]);
	    }for (b in Object.getOwnPropertyNames(this)) {
	      "function" != typeof this[b] && (this[b] = null);
	    }
	  }, a.fn.owlCarousel.Constructor.Plugins.AutoHeight = e;
	}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
	  var e = function e(b) {
	    this._core = b, this._videos = {}, this._playing = null, this._handlers = { "initialized.owl.carousel": a.proxy(function (a) {
	        a.namespace && this._core.register({ type: "state", name: "playing", tags: ["interacting"] });
	      }, this), "resize.owl.carousel": a.proxy(function (a) {
	        a.namespace && this._core.settings.video && this.isInFullScreen() && a.preventDefault();
	      }, this), "refreshed.owl.carousel": a.proxy(function (a) {
	        a.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove();
	      }, this), "changed.owl.carousel": a.proxy(function (a) {
	        a.namespace && "position" === a.property.name && this._playing && this.stop();
	      }, this), "prepared.owl.carousel": a.proxy(function (b) {
	        if (b.namespace) {
	          var c = a(b.content).find(".owl-video");c.length && (c.css("display", "none"), this.fetch(c, a(b.content)));
	        }
	      }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers), this._core.$element.on("click.owl.video", ".owl-video-play-icon", a.proxy(function (a) {
	      this.play(a);
	    }, this));
	  };e.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }, e.prototype.fetch = function (a, b) {
	    var c = function () {
	      return a.attr("data-vimeo-id") ? "vimeo" : a.attr("data-vzaar-id") ? "vzaar" : "youtube";
	    }(),
	        d = a.attr("data-vimeo-id") || a.attr("data-youtube-id") || a.attr("data-vzaar-id"),
	        e = a.attr("data-width") || this._core.settings.videoWidth,
	        f = a.attr("data-height") || this._core.settings.videoHeight,
	        g = a.attr("href");if (!g) throw new Error("Missing video URL.");if (d = g.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/), d[3].indexOf("youtu") > -1) c = "youtube";else if (d[3].indexOf("vimeo") > -1) c = "vimeo";else {
	      if (!(d[3].indexOf("vzaar") > -1)) throw new Error("Video URL not supported.");c = "vzaar";
	    }d = d[6], this._videos[g] = { type: c, id: d, width: e, height: f }, b.attr("data-video", g), this.thumbnail(a, this._videos[g]);
	  }, e.prototype.thumbnail = function (b, c) {
	    var d,
	        e,
	        f,
	        g = c.width && c.height ? 'style="width:' + c.width + "px;height:" + c.height + 'px;"' : "",
	        h = b.find("img"),
	        i = "src",
	        j = "",
	        k = this._core.settings,
	        l = function l(a) {
	      e = '<div class="owl-video-play-icon"></div>', d = k.lazyLoad ? '<div class="owl-video-tn ' + j + '" ' + i + '="' + a + '"></div>' : '<div class="owl-video-tn" style="opacity:1;background-image:url(' + a + ')"></div>', b.after(d), b.after(e);
	    };return b.wrap('<div class="owl-video-wrapper"' + g + "></div>"), this._core.settings.lazyLoad && (i = "data-src", j = "owl-lazy"), h.length ? (l(h.attr(i)), h.remove(), !1) : void ("youtube" === c.type ? (f = "//img.youtube.com/vi/" + c.id + "/hqdefault.jpg", l(f)) : "vimeo" === c.type ? a.ajax({ type: "GET", url: "//vimeo.com/api/v2/video/" + c.id + ".json", jsonp: "callback", dataType: "jsonp", success: function success(a) {
	        f = a[0].thumbnail_large, l(f);
	      } }) : "vzaar" === c.type && a.ajax({ type: "GET", url: "//vzaar.com/api/videos/" + c.id + ".json", jsonp: "callback", dataType: "jsonp", success: function success(a) {
	        f = a.framegrab_url, l(f);
	      } }));
	  }, e.prototype.stop = function () {
	    this._core.trigger("stop", null, "video"), this._playing.find(".owl-video-frame").remove(), this._playing.removeClass("owl-video-playing"), this._playing = null, this._core.leave("playing"), this._core.trigger("stopped", null, "video");
	  }, e.prototype.play = function (b) {
	    var c,
	        d = a(b.target),
	        e = d.closest("." + this._core.settings.itemClass),
	        f = this._videos[e.attr("data-video")],
	        g = f.width || "100%",
	        h = f.height || this._core.$stage.height();this._playing || (this._core.enter("playing"), this._core.trigger("play", null, "video"), e = this._core.items(this._core.relative(e.index())), this._core.reset(e.index()), "youtube" === f.type ? c = '<iframe width="' + g + '" height="' + h + '" src="//www.youtube.com/embed/' + f.id + "?autoplay=1&rel=0&v=" + f.id + '" frameborder="0" allowfullscreen></iframe>' : "vimeo" === f.type ? c = '<iframe src="//player.vimeo.com/video/' + f.id + '?autoplay=1" width="' + g + '" height="' + h + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' : "vzaar" === f.type && (c = '<iframe frameborder="0"height="' + h + '"width="' + g + '" allowfullscreen mozallowfullscreen webkitAllowFullScreen src="//view.vzaar.com/' + f.id + '/player?autoplay=true"></iframe>'), a('<div class="owl-video-frame">' + c + "</div>").insertAfter(e.find(".owl-video")), this._playing = e.addClass("owl-video-playing"));
	  }, e.prototype.isInFullScreen = function () {
	    var b = c.fullscreenElement || c.mozFullScreenElement || c.webkitFullscreenElement;return b && a(b).parent().hasClass("owl-video-frame");
	  }, e.prototype.destroy = function () {
	    var a, b;this._core.$element.off("click.owl.video");for (a in this._handlers) {
	      this._core.$element.off(a, this._handlers[a]);
	    }for (b in Object.getOwnPropertyNames(this)) {
	      "function" != typeof this[b] && (this[b] = null);
	    }
	  }, a.fn.owlCarousel.Constructor.Plugins.Video = e;
	}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
	  var e = function e(b) {
	    this.core = b, this.core.options = a.extend({}, e.Defaults, this.core.options), this.swapping = !0, this.previous = d, this.next = d, this.handlers = { "change.owl.carousel": a.proxy(function (a) {
	        a.namespace && "position" == a.property.name && (this.previous = this.core.current(), this.next = a.property.value);
	      }, this), "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": a.proxy(function (a) {
	        a.namespace && (this.swapping = "translated" == a.type);
	      }, this), "translate.owl.carousel": a.proxy(function (a) {
	        a.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap();
	      }, this) }, this.core.$element.on(this.handlers);
	  };e.Defaults = { animateOut: !1, animateIn: !1 }, e.prototype.swap = function () {
	    if (1 === this.core.settings.items && a.support.animation && a.support.transition) {
	      this.core.speed(0);var b,
	          c = a.proxy(this.clear, this),
	          d = this.core.$stage.children().eq(this.previous),
	          e = this.core.$stage.children().eq(this.next),
	          f = this.core.settings.animateIn,
	          g = this.core.settings.animateOut;this.core.current() !== this.previous && (g && (b = this.core.coordinates(this.previous) - this.core.coordinates(this.next), d.one(a.support.animation.end, c).css({ left: b + "px" }).addClass("animated owl-animated-out").addClass(g)), f && e.one(a.support.animation.end, c).addClass("animated owl-animated-in").addClass(f));
	    }
	  }, e.prototype.clear = function (b) {
	    a(b.target).css({ left: "" }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.onTransitionEnd();
	  }, e.prototype.destroy = function () {
	    var a, b;for (a in this.handlers) {
	      this.core.$element.off(a, this.handlers[a]);
	    }for (b in Object.getOwnPropertyNames(this)) {
	      "function" != typeof this[b] && (this[b] = null);
	    }
	  }, a.fn.owlCarousel.Constructor.Plugins.Animate = e;
	}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
	  var e = function e(b) {
	    this._core = b, this._timeout = null, this._paused = !1, this._handlers = { "changed.owl.carousel": a.proxy(function (a) {
	        a.namespace && "settings" === a.property.name ? this._core.settings.autoplay ? this.play() : this.stop() : a.namespace && "position" === a.property.name && this._core.settings.autoplay && this._setAutoPlayInterval();
	      }, this), "initialized.owl.carousel": a.proxy(function (a) {
	        a.namespace && this._core.settings.autoplay && this.play();
	      }, this), "play.owl.autoplay": a.proxy(function (a, b, c) {
	        a.namespace && this.play(b, c);
	      }, this), "stop.owl.autoplay": a.proxy(function (a) {
	        a.namespace && this.stop();
	      }, this), "mouseover.owl.autoplay": a.proxy(function () {
	        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
	      }, this), "mouseleave.owl.autoplay": a.proxy(function () {
	        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play();
	      }, this), "touchstart.owl.core": a.proxy(function () {
	        this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
	      }, this), "touchend.owl.core": a.proxy(function () {
	        this._core.settings.autoplayHoverPause && this.play();
	      }, this) }, this._core.$element.on(this._handlers), this._core.options = a.extend({}, e.Defaults, this._core.options);
	  };e.Defaults = { autoplay: !1, autoplayTimeout: 5e3, autoplayHoverPause: !1, autoplaySpeed: !1 }, e.prototype.play = function (a, b) {
	    this._paused = !1, this._core.is("rotating") || (this._core.enter("rotating"), this._setAutoPlayInterval());
	  }, e.prototype._getNextTimeout = function (d, e) {
	    return this._timeout && b.clearTimeout(this._timeout), b.setTimeout(a.proxy(function () {
	      this._paused || this._core.is("busy") || this._core.is("interacting") || c.hidden || this._core.next(e || this._core.settings.autoplaySpeed);
	    }, this), d || this._core.settings.autoplayTimeout);
	  }, e.prototype._setAutoPlayInterval = function () {
	    this._timeout = this._getNextTimeout();
	  }, e.prototype.stop = function () {
	    this._core.is("rotating") && (b.clearTimeout(this._timeout), this._core.leave("rotating"));
	  }, e.prototype.pause = function () {
	    this._core.is("rotating") && (this._paused = !0);
	  }, e.prototype.destroy = function () {
	    var a, b;this.stop();for (a in this._handlers) {
	      this._core.$element.off(a, this._handlers[a]);
	    }for (b in Object.getOwnPropertyNames(this)) {
	      "function" != typeof this[b] && (this[b] = null);
	    }
	  }, a.fn.owlCarousel.Constructor.Plugins.autoplay = e;
	}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
	  "use strict";
	  var e = function e(b) {
	    this._core = b, this._initialized = !1, this._pages = [], this._controls = {}, this._templates = [], this.$element = this._core.$element, this._overrides = { next: this._core.next, prev: this._core.prev, to: this._core.to }, this._handlers = { "prepared.owl.carousel": a.proxy(function (b) {
	        b.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + a(b.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>");
	      }, this), "added.owl.carousel": a.proxy(function (a) {
	        a.namespace && this._core.settings.dotsData && this._templates.splice(a.position, 0, this._templates.pop());
	      }, this), "remove.owl.carousel": a.proxy(function (a) {
	        a.namespace && this._core.settings.dotsData && this._templates.splice(a.position, 1);
	      }, this), "changed.owl.carousel": a.proxy(function (a) {
	        a.namespace && "position" == a.property.name && this.draw();
	      }, this), "initialized.owl.carousel": a.proxy(function (a) {
	        a.namespace && !this._initialized && (this._core.trigger("initialize", null, "navigation"), this.initialize(), this.update(), this.draw(), this._initialized = !0, this._core.trigger("initialized", null, "navigation"));
	      }, this), "refreshed.owl.carousel": a.proxy(function (a) {
	        a.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation"));
	      }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this.$element.on(this._handlers);
	  };e.Defaults = { nav: !1, navText: ["prev", "next"], navSpeed: !1, navElement: "div", navContainer: !1, navContainerClass: "owl-nav", navClass: ["owl-prev", "owl-next"], slideBy: 1, dotClass: "owl-dot", dotsClass: "owl-dots", dots: !0, dotsEach: !1, dotsData: !1, dotsSpeed: !1, dotsContainer: !1 }, e.prototype.initialize = function () {
	    var b,
	        c = this._core.settings;this._controls.$relative = (c.navContainer ? a(c.navContainer) : a("<div>").addClass(c.navContainerClass).appendTo(this.$element)).addClass("disabled"), this._controls.$previous = a("<" + c.navElement + ">").addClass(c.navClass[0]).html(c.navText[0]).prependTo(this._controls.$relative).on("click", a.proxy(function (a) {
	      this.prev(c.navSpeed);
	    }, this)), this._controls.$next = a("<" + c.navElement + ">").addClass(c.navClass[1]).html(c.navText[1]).appendTo(this._controls.$relative).on("click", a.proxy(function (a) {
	      this.next(c.navSpeed);
	    }, this)), c.dotsData || (this._templates = [a("<div>").addClass(c.dotClass).append(a("<span>")).prop("outerHTML")]), this._controls.$absolute = (c.dotsContainer ? a(c.dotsContainer) : a("<div>").addClass(c.dotsClass).appendTo(this.$element)).addClass("disabled"), this._controls.$absolute.on("click", "div", a.proxy(function (b) {
	      var d = a(b.target).parent().is(this._controls.$absolute) ? a(b.target).index() : a(b.target).parent().index();b.preventDefault(), this.to(d, c.dotsSpeed);
	    }, this));for (b in this._overrides) {
	      this._core[b] = a.proxy(this[b], this);
	    }
	  }, e.prototype.destroy = function () {
	    var a, b, c, d;for (a in this._handlers) {
	      this.$element.off(a, this._handlers[a]);
	    }for (b in this._controls) {
	      this._controls[b].remove();
	    }for (d in this.overides) {
	      this._core[d] = this._overrides[d];
	    }for (c in Object.getOwnPropertyNames(this)) {
	      "function" != typeof this[c] && (this[c] = null);
	    }
	  }, e.prototype.update = function () {
	    var a,
	        b,
	        c,
	        d = this._core.clones().length / 2,
	        e = d + this._core.items().length,
	        f = this._core.maximum(!0),
	        g = this._core.settings,
	        h = g.center || g.autoWidth || g.dotsData ? 1 : g.dotsEach || g.items;if ("page" !== g.slideBy && (g.slideBy = Math.min(g.slideBy, g.items)), g.dots || "page" == g.slideBy) for (this._pages = [], a = d, b = 0, c = 0; a < e; a++) {
	      if (b >= h || 0 === b) {
	        if (this._pages.push({ start: Math.min(f, a - d), end: a - d + h - 1 }), Math.min(f, a - d) === f) break;b = 0, ++c;
	      }b += this._core.mergers(this._core.relative(a));
	    }
	  }, e.prototype.draw = function () {
	    var b,
	        c = this._core.settings,
	        d = this._core.items().length <= c.items,
	        e = this._core.relative(this._core.current()),
	        f = c.loop || c.rewind;this._controls.$relative.toggleClass("disabled", !c.nav || d), c.nav && (this._controls.$previous.toggleClass("disabled", !f && e <= this._core.minimum(!0)), this._controls.$next.toggleClass("disabled", !f && e >= this._core.maximum(!0))), this._controls.$absolute.toggleClass("disabled", !c.dots || d), c.dots && (b = this._pages.length - this._controls.$absolute.children().length, c.dotsData && 0 !== b ? this._controls.$absolute.html(this._templates.join("")) : b > 0 ? this._controls.$absolute.append(new Array(b + 1).join(this._templates[0])) : b < 0 && this._controls.$absolute.children().slice(b).remove(), this._controls.$absolute.find(".active").removeClass("active"), this._controls.$absolute.children().eq(a.inArray(this.current(), this._pages)).addClass("active"));
	  }, e.prototype.onTrigger = function (b) {
	    var c = this._core.settings;b.page = { index: a.inArray(this.current(), this._pages), count: this._pages.length, size: c && (c.center || c.autoWidth || c.dotsData ? 1 : c.dotsEach || c.items) };
	  }, e.prototype.current = function () {
	    var b = this._core.relative(this._core.current());return a.grep(this._pages, a.proxy(function (a, c) {
	      return a.start <= b && a.end >= b;
	    }, this)).pop();
	  }, e.prototype.getPosition = function (b) {
	    var c,
	        d,
	        e = this._core.settings;return "page" == e.slideBy ? (c = a.inArray(this.current(), this._pages), d = this._pages.length, b ? ++c : --c, c = this._pages[(c % d + d) % d].start) : (c = this._core.relative(this._core.current()), d = this._core.items().length, b ? c += e.slideBy : c -= e.slideBy), c;
	  }, e.prototype.next = function (b) {
	    a.proxy(this._overrides.to, this._core)(this.getPosition(!0), b);
	  }, e.prototype.prev = function (b) {
	    a.proxy(this._overrides.to, this._core)(this.getPosition(!1), b);
	  }, e.prototype.to = function (b, c, d) {
	    var e;!d && this._pages.length ? (e = this._pages.length, a.proxy(this._overrides.to, this._core)(this._pages[(b % e + e) % e].start, c)) : a.proxy(this._overrides.to, this._core)(b, c);
	  }, a.fn.owlCarousel.Constructor.Plugins.Navigation = e;
	}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
	  "use strict";
	  var e = function e(c) {
	    this._core = c, this._hashes = {}, this.$element = this._core.$element, this._handlers = { "initialized.owl.carousel": a.proxy(function (c) {
	        c.namespace && "URLHash" === this._core.settings.startPosition && a(b).trigger("hashchange.owl.navigation");
	      }, this), "prepared.owl.carousel": a.proxy(function (b) {
	        if (b.namespace) {
	          var c = a(b.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");if (!c) return;this._hashes[c] = b.content;
	        }
	      }, this), "changed.owl.carousel": a.proxy(function (c) {
	        if (c.namespace && "position" === c.property.name) {
	          var d = this._core.items(this._core.relative(this._core.current())),
	              e = a.map(this._hashes, function (a, b) {
	            return a === d ? b : null;
	          }).join();if (!e || b.location.hash.slice(1) === e) return;b.location.hash = e;
	        }
	      }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this.$element.on(this._handlers), a(b).on("hashchange.owl.navigation", a.proxy(function (a) {
	      var c = b.location.hash.substring(1),
	          e = this._core.$stage.children(),
	          f = this._hashes[c] && e.index(this._hashes[c]);f !== d && f !== this._core.current() && this._core.to(this._core.relative(f), !1, !0);
	    }, this));
	  };e.Defaults = { URLhashListener: !1 }, e.prototype.destroy = function () {
	    var c, d;a(b).off("hashchange.owl.navigation");for (c in this._handlers) {
	      this._core.$element.off(c, this._handlers[c]);
	    }for (d in Object.getOwnPropertyNames(this)) {
	      "function" != typeof this[d] && (this[d] = null);
	    }
	  }, a.fn.owlCarousel.Constructor.Plugins.Hash = e;
	}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
	  function e(b, c) {
	    var e = !1,
	        f = b.charAt(0).toUpperCase() + b.slice(1);return a.each((b + " " + h.join(f + " ") + f).split(" "), function (a, b) {
	      if (g[b] !== d) return e = !c || b, !1;
	    }), e;
	  }function f(a) {
	    return e(a, !0);
	  }var g = a("<support>").get(0).style,
	      h = "Webkit Moz O ms".split(" "),
	      i = { transition: { end: { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd", transition: "transitionend" } }, animation: { end: { WebkitAnimation: "webkitAnimationEnd", MozAnimation: "animationend", OAnimation: "oAnimationEnd", animation: "animationend" } } },
	      j = { csstransforms: function csstransforms() {
	      return !!e("transform");
	    }, csstransforms3d: function csstransforms3d() {
	      return !!e("perspective");
	    }, csstransitions: function csstransitions() {
	      return !!e("transition");
	    }, cssanimations: function cssanimations() {
	      return !!e("animation");
	    } };j.csstransitions() && (a.support.transition = new String(f("transition")), a.support.transition.end = i.transition.end[a.support.transition]), j.cssanimations() && (a.support.animation = new String(f("animation")), a.support.animation.end = i.animation.end[a.support.animation]), j.csstransforms() && (a.support.transform = new String(f("transform")), a.support.transform3d = j.csstransforms3d());
	}(window.Zepto || window.jQuery, window, document);

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*! PhotoSwipe Default UI - 4.1.1 - 2015-12-24
	* http://photoswipe.com
	* Copyright (c) 2015 Dmitry Semenov; */
	!function (a, b) {
	   true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (b), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = b() : a.PhotoSwipeUI_Default = b();
	}(undefined, function () {
	  "use strict";
	  var a = function a(_a, b) {
	    var c,
	        d,
	        e,
	        f,
	        g,
	        h,
	        i,
	        j,
	        k,
	        l,
	        m,
	        n,
	        o,
	        p,
	        q,
	        r,
	        s,
	        t,
	        u,
	        v = this,
	        w = !1,
	        x = !0,
	        y = !0,
	        z = { barsSize: { top: 44, bottom: "auto" }, closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"], timeToIdle: 4e3, timeToIdleOutside: 1e3, loadingIndicatorDelay: 1e3, addCaptionHTMLFn: function addCaptionHTMLFn(a, b) {
	        return a.title ? (b.children[0].innerHTML = a.title, !0) : (b.children[0].innerHTML = "", !1);
	      }, closeEl: !0, captionEl: !0, fullscreenEl: !0, zoomEl: !0, shareEl: !0, counterEl: !0, arrowEl: !0, preloaderEl: !0, tapToClose: !1, tapToToggleControls: !0, clickToCloseNonZoomable: !0, shareButtons: [{ id: "facebook", label: "Share on Facebook", url: "https://www.facebook.com/sharer/sharer.php?u={{url}}" }, { id: "twitter", label: "Tweet", url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}" }, { id: "pinterest", label: "Pin it", url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}" }, { id: "download", label: "Download image", url: "{{raw_image_url}}", download: !0 }], getImageURLForShare: function getImageURLForShare() {
	        return _a.currItem.src || "";
	      }, getPageURLForShare: function getPageURLForShare() {
	        return window.location.href;
	      }, getTextForShare: function getTextForShare() {
	        return _a.currItem.title || "";
	      }, indexIndicatorSep: " / ", fitControlsWidth: 1200 },
	        A = function A(a) {
	      if (r) return !0;a = a || window.event, q.timeToIdle && q.mouseUsed && !k && K();for (var c, d, e = a.target || a.srcElement, f = e.getAttribute("class") || "", g = 0; g < S.length; g++) {
	        c = S[g], c.onTap && f.indexOf("pswp__" + c.name) > -1 && (c.onTap(), d = !0);
	      }if (d) {
	        a.stopPropagation && a.stopPropagation(), r = !0;var h = b.features.isOldAndroid ? 600 : 30;s = setTimeout(function () {
	          r = !1;
	        }, h);
	      }
	    },
	        B = function B() {
	      return !_a.likelyTouchDevice || q.mouseUsed || screen.width > q.fitControlsWidth;
	    },
	        C = function C(a, c, d) {
	      b[(d ? "add" : "remove") + "Class"](a, "pswp__" + c);
	    },
	        D = function D() {
	      var a = 1 === q.getNumItemsFn();a !== p && (C(d, "ui--one-slide", a), p = a);
	    },
	        E = function E() {
	      C(i, "share-modal--hidden", y);
	    },
	        F = function F() {
	      return y = !y, y ? (b.removeClass(i, "pswp__share-modal--fade-in"), setTimeout(function () {
	        y && E();
	      }, 300)) : (E(), setTimeout(function () {
	        y || b.addClass(i, "pswp__share-modal--fade-in");
	      }, 30)), y || H(), !1;
	    },
	        G = function G(b) {
	      b = b || window.event;var c = b.target || b.srcElement;return _a.shout("shareLinkClick", b, c), c.href ? c.hasAttribute("download") ? !0 : (window.open(c.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)), y || F(), !1) : !1;
	    },
	        H = function H() {
	      for (var a, b, c, d, e, f = "", g = 0; g < q.shareButtons.length; g++) {
	        a = q.shareButtons[g], c = q.getImageURLForShare(a), d = q.getPageURLForShare(a), e = q.getTextForShare(a), b = a.url.replace("{{url}}", encodeURIComponent(d)).replace("{{image_url}}", encodeURIComponent(c)).replace("{{raw_image_url}}", c).replace("{{text}}", encodeURIComponent(e)), f += '<a href="' + b + '" target="_blank" class="pswp__share--' + a.id + '"' + (a.download ? "download" : "") + ">" + a.label + "</a>", q.parseShareButtonOut && (f = q.parseShareButtonOut(a, f));
	      }i.children[0].innerHTML = f, i.children[0].onclick = G;
	    },
	        I = function I(a) {
	      for (var c = 0; c < q.closeElClasses.length; c++) {
	        if (b.hasClass(a, "pswp__" + q.closeElClasses[c])) return !0;
	      }
	    },
	        J = 0,
	        K = function K() {
	      clearTimeout(u), J = 0, k && v.setIdle(!1);
	    },
	        L = function L(a) {
	      a = a ? a : window.event;var b = a.relatedTarget || a.toElement;b && "HTML" !== b.nodeName || (clearTimeout(u), u = setTimeout(function () {
	        v.setIdle(!0);
	      }, q.timeToIdleOutside));
	    },
	        M = function M() {
	      q.fullscreenEl && !b.features.isOldAndroid && (c || (c = v.getFullscreenAPI()), c ? (b.bind(document, c.eventK, v.updateFullscreen), v.updateFullscreen(), b.addClass(_a.template, "pswp--supports-fs")) : b.removeClass(_a.template, "pswp--supports-fs"));
	    },
	        N = function N() {
	      q.preloaderEl && (O(!0), l("beforeChange", function () {
	        clearTimeout(o), o = setTimeout(function () {
	          _a.currItem && _a.currItem.loading ? (!_a.allowProgressiveImg() || _a.currItem.img && !_a.currItem.img.naturalWidth) && O(!1) : O(!0);
	        }, q.loadingIndicatorDelay);
	      }), l("imageLoadComplete", function (b, c) {
	        _a.currItem === c && O(!0);
	      }));
	    },
	        O = function O(a) {
	      n !== a && (C(m, "preloader--active", !a), n = a);
	    },
	        P = function P(a) {
	      var c = a.vGap;if (B()) {
	        var g = q.barsSize;if (q.captionEl && "auto" === g.bottom) {
	          if (f || (f = b.createEl("pswp__caption pswp__caption--fake"), f.appendChild(b.createEl("pswp__caption__center")), d.insertBefore(f, e), b.addClass(d, "pswp__ui--fit")), q.addCaptionHTMLFn(a, f, !0)) {
	            var h = f.clientHeight;c.bottom = parseInt(h, 10) || 44;
	          } else c.bottom = g.top;
	        } else c.bottom = "auto" === g.bottom ? 0 : g.bottom;c.top = g.top;
	      } else c.top = c.bottom = 0;
	    },
	        Q = function Q() {
	      q.timeToIdle && l("mouseUsed", function () {
	        b.bind(document, "mousemove", K), b.bind(document, "mouseout", L), t = setInterval(function () {
	          J++, 2 === J && v.setIdle(!0);
	        }, q.timeToIdle / 2);
	      });
	    },
	        R = function R() {
	      l("onVerticalDrag", function (a) {
	        x && .95 > a ? v.hideControls() : !x && a >= .95 && v.showControls();
	      });var a;l("onPinchClose", function (b) {
	        x && .9 > b ? (v.hideControls(), a = !0) : a && !x && b > .9 && v.showControls();
	      }), l("zoomGestureEnded", function () {
	        a = !1, a && !x && v.showControls();
	      });
	    },
	        S = [{ name: "caption", option: "captionEl", onInit: function onInit(a) {
	        e = a;
	      } }, { name: "share-modal", option: "shareEl", onInit: function onInit(a) {
	        i = a;
	      }, onTap: function onTap() {
	        F();
	      } }, { name: "button--share", option: "shareEl", onInit: function onInit(a) {
	        h = a;
	      }, onTap: function onTap() {
	        F();
	      } }, { name: "button--zoom", option: "zoomEl", onTap: _a.toggleDesktopZoom }, { name: "counter", option: "counterEl", onInit: function onInit(a) {
	        g = a;
	      } }, { name: "button--close", option: "closeEl", onTap: _a.close }, { name: "button--arrow--left", option: "arrowEl", onTap: _a.prev }, { name: "button--arrow--right", option: "arrowEl", onTap: _a.next }, { name: "button--fs", option: "fullscreenEl", onTap: function onTap() {
	        c.isFullscreen() ? c.exit() : c.enter();
	      } }, { name: "preloader", option: "preloaderEl", onInit: function onInit(a) {
	        m = a;
	      } }],
	        T = function T() {
	      var a,
	          c,
	          e,
	          f = function f(d) {
	        if (d) for (var f = d.length, g = 0; f > g; g++) {
	          a = d[g], c = a.className;for (var h = 0; h < S.length; h++) {
	            e = S[h], c.indexOf("pswp__" + e.name) > -1 && (q[e.option] ? (b.removeClass(a, "pswp__element--disabled"), e.onInit && e.onInit(a)) : b.addClass(a, "pswp__element--disabled"));
	          }
	        }
	      };f(d.children);var g = b.getChildByClass(d, "pswp__top-bar");g && f(g.children);
	    };v.init = function () {
	      b.extend(_a.options, z, !0), q = _a.options, d = b.getChildByClass(_a.scrollWrap, "pswp__ui"), l = _a.listen, R(), l("beforeChange", v.update), l("doubleTap", function (b) {
	        var c = _a.currItem.initialZoomLevel;_a.getZoomLevel() !== c ? _a.zoomTo(c, b, 333) : _a.zoomTo(q.getDoubleTapZoom(!1, _a.currItem), b, 333);
	      }), l("preventDragEvent", function (a, b, c) {
	        var d = a.target || a.srcElement;d && d.getAttribute("class") && a.type.indexOf("mouse") > -1 && (d.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(d.tagName)) && (c.prevent = !1);
	      }), l("bindEvents", function () {
	        b.bind(d, "pswpTap click", A), b.bind(_a.scrollWrap, "pswpTap", v.onGlobalTap), _a.likelyTouchDevice || b.bind(_a.scrollWrap, "mouseover", v.onMouseOver);
	      }), l("unbindEvents", function () {
	        y || F(), t && clearInterval(t), b.unbind(document, "mouseout", L), b.unbind(document, "mousemove", K), b.unbind(d, "pswpTap click", A), b.unbind(_a.scrollWrap, "pswpTap", v.onGlobalTap), b.unbind(_a.scrollWrap, "mouseover", v.onMouseOver), c && (b.unbind(document, c.eventK, v.updateFullscreen), c.isFullscreen() && (q.hideAnimationDuration = 0, c.exit()), c = null);
	      }), l("destroy", function () {
	        q.captionEl && (f && d.removeChild(f), b.removeClass(e, "pswp__caption--empty")), i && (i.children[0].onclick = null), b.removeClass(d, "pswp__ui--over-close"), b.addClass(d, "pswp__ui--hidden"), v.setIdle(!1);
	      }), q.showAnimationDuration || b.removeClass(d, "pswp__ui--hidden"), l("initialZoomIn", function () {
	        q.showAnimationDuration && b.removeClass(d, "pswp__ui--hidden");
	      }), l("initialZoomOut", function () {
	        b.addClass(d, "pswp__ui--hidden");
	      }), l("parseVerticalMargin", P), T(), q.shareEl && h && i && (y = !0), D(), Q(), M(), N();
	    }, v.setIdle = function (a) {
	      k = a, C(d, "ui--idle", a);
	    }, v.update = function () {
	      x && _a.currItem ? (v.updateIndexIndicator(), q.captionEl && (q.addCaptionHTMLFn(_a.currItem, e), C(e, "caption--empty", !_a.currItem.title)), w = !0) : w = !1, y || F(), D();
	    }, v.updateFullscreen = function (d) {
	      d && setTimeout(function () {
	        _a.setScrollOffset(0, b.getScrollY());
	      }, 50), b[(c.isFullscreen() ? "add" : "remove") + "Class"](_a.template, "pswp--fs");
	    }, v.updateIndexIndicator = function () {
	      q.counterEl && (g.innerHTML = _a.getCurrentIndex() + 1 + q.indexIndicatorSep + q.getNumItemsFn());
	    }, v.onGlobalTap = function (c) {
	      c = c || window.event;var d = c.target || c.srcElement;if (!r) if (c.detail && "mouse" === c.detail.pointerType) {
	        if (I(d)) return void _a.close();b.hasClass(d, "pswp__img") && (1 === _a.getZoomLevel() && _a.getZoomLevel() <= _a.currItem.fitRatio ? q.clickToCloseNonZoomable && _a.close() : _a.toggleDesktopZoom(c.detail.releasePoint));
	      } else if (q.tapToToggleControls && (x ? v.hideControls() : v.showControls()), q.tapToClose && (b.hasClass(d, "pswp__img") || I(d))) return void _a.close();
	    }, v.onMouseOver = function (a) {
	      a = a || window.event;var b = a.target || a.srcElement;C(d, "ui--over-close", I(b));
	    }, v.hideControls = function () {
	      b.addClass(d, "pswp__ui--hidden"), x = !1;
	    }, v.showControls = function () {
	      x = !0, w || v.update(), b.removeClass(d, "pswp__ui--hidden");
	    }, v.supportsFullscreen = function () {
	      var a = document;return !!(a.exitFullscreen || a.mozCancelFullScreen || a.webkitExitFullscreen || a.msExitFullscreen);
	    }, v.getFullscreenAPI = function () {
	      var b,
	          c = document.documentElement,
	          d = "fullscreenchange";return c.requestFullscreen ? b = { enterK: "requestFullscreen", exitK: "exitFullscreen", elementK: "fullscreenElement", eventK: d } : c.mozRequestFullScreen ? b = { enterK: "mozRequestFullScreen", exitK: "mozCancelFullScreen", elementK: "mozFullScreenElement", eventK: "moz" + d } : c.webkitRequestFullscreen ? b = { enterK: "webkitRequestFullscreen", exitK: "webkitExitFullscreen", elementK: "webkitFullscreenElement", eventK: "webkit" + d } : c.msRequestFullscreen && (b = { enterK: "msRequestFullscreen", exitK: "msExitFullscreen", elementK: "msFullscreenElement", eventK: "MSFullscreenChange" }), b && (b.enter = function () {
	        return j = q.closeOnScroll, q.closeOnScroll = !1, "webkitRequestFullscreen" !== this.enterK ? _a.template[this.enterK]() : void _a.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
	      }, b.exit = function () {
	        return q.closeOnScroll = j, document[this.exitK]();
	      }, b.isFullscreen = function () {
	        return document[this.elementK];
	      }), b;
	    };
	  };return a;
	});

/***/ }),

/***/ 384:
341,

/***/ 385:
341,

/***/ 386:
341,

/***/ 393:
341,

/***/ 394:
341,

/***/ 395:
341,

/***/ 396:
341,

/***/ 397:
341,

/***/ 398:
341

});


// WEBPACK FOOTER //
// bundle-0966878f95eb6a9360dd.js